// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:32:05.143Z
// Property: The Aidan (ID: 5679206272860160)
// Collections: 19 amenities, 7 floorplans (live), 27 photos, 82 POIs, 11 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5679206272860160",
  "property_external_id": "4786611",
  "property_zillow_url": "https://www.zillow.com/b/forest-brook-apartments-lewisville-tx-5XhssC/",
  "property_apartments_url": "https://www.apartments.com/the-aidan-lewisville-tx/m940nnl",
  "property_google_business_url": "https://www.google.com/maps/place/The+Aidan/@33.0074342,-96.992368,17z/data=!4m13!1m7!3m6!1s0x864c2e8dfa320e61:0x164e7fae9f84b88f!2s165+Forestbrook+Dr,+Lewisville,+TX+75067!3b1!8m2!3d33.0074342!4d-96.990174!3m4!1s0x864c2e8e02d82f91:0x1ee452a119dd3351!8m2!3d33.0083221!4d-96.9900995",
  "property_linkedin_url": "https://www.linkedin.com/in/aidan-book-099105162",
  "property_hubspot_id": "8443907420",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-aidan",
  "property_name": "The Aidan",
  "property_website_url": "https://www.theaidanapts.com",
  "property_domain": "https://www.theaidanapts.com",
  "property_address": "165 Forestbrook Dr",
  "property_full_address": "165 Forestbrook Dr, Lewisville, TX 75067",
  "property_address_1": "165 Forestbrook Dr",
  "property_address_2": null,
  "property_address_city": "Lewisville",
  "property_address_state": "TX",
  "property_address_zip_full": "75067-7867",
  "property_address_zip": "75067",
  "property_address_country": "US",
  "property_address_county": "Denton County",
  "property_neighborhood_address": "Lewisville/Flower Mound",
  "property_address_latitude": "33.0070349",
  "property_address_longitude": "-96.9918854",
  "property_email": "theaidan@alapts.com",
  "property_phone": "(972) 459-7550",
  "property_call_tracking_phone": "469-649-7509",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Newly renovated Lewisville apartments with DFW access made easy.</strong> Explore one, two, and three bedroom homes with granite kitchens, wood-style flooring, walk-in closets, and private outdoor space—then compare floor plans or schedule your tour at The Aidan.</p>",
  "property_long_description": "<p><strong>Newly renovated apartments with a Lewisville address that keeps DFW within reach.</strong> At The Aidan, you can choose a one, two, or three bedroom layout with everyday-ready details—wood-style flooring, private patios or balconies, walk-in closets, washer/dryer connections, and kitchens finished with granite countertops, decorative tile backsplashes, and stainless steel or black appliances. Select homes add fireplaces, USB outlets, and in-home washers and dryers.</p><p>Outside your door, the community brings the easy extras together: a resort-inspired pool with hot tub, 24-hour fitness center and cycling studio, outdoor kitchen, WiFi café with Starbucks coffee bar, package lockers, controlled-access gates, and a pet play area. Explore the full <a href=\"/amenities\">amenities</a> or compare <a href=\"/floor-plans\">floor plans</a> when you’re ready.</p><p>Set in the Lewisville/Flower Mound area near SH 121 and I-35E, The Aidan puts you close to Old Town Lewisville dining and arts, Lewisville Lake, LLELA trails, and DFW Airport—with shopping and daily essentials minutes away.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-b2d4-702f-9a9b-0df70105ff47.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
    "public_id": "019e89c3-b2d4-702f-9a9b-0df70105ff47",
    "storage_key": "property/5679206272860160/019e89c3-b2d4-702f-9a9b-0df70105ff47.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "232",
  "property_year_built": "1998",
  "property_year_renovated": "2021",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.25862068965517",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8689921.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://theaidan.loftliving.com/login",
  "property_apply_now_url": "https://8689921.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e705d-b824-75db-bcbb-472b640671b9.webp",
  "property_primary_logo_media": {
    "alt_text": "The Aidan Premier Apartments logo.",
    "public_id": "019e705d-b824-75db-bcbb-472b640671b9",
    "storage_key": "property/5679206272860160/019e705d-b824-75db-bcbb-472b640671b9.webp",
    "width": 1522,
    "height": 565
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e705d-b8fe-7652-a3c8-1709df179e5c.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Aidan logo",
    "public_id": "019e705d-b8fe-7652-a3c8-1709df179e5c",
    "storage_key": "property/5679206272860160/019e705d-b8fe-7652-a3c8-1709df179e5c.webp",
    "width": 1523,
    "height": 565
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e705d-bde7-7041-8e1f-7b0dfdc9cbfc.webp",
  "property_icon_media": {
    "alt_text": "The Aidan logo",
    "public_id": "019e705d-bde7-7041-8e1f-7b0dfdc9cbfc",
    "storage_key": "property/5679206272860160/019e705d-bde7-7041-8e1f-7b0dfdc9cbfc.webp",
    "width": 1382,
    "height": 1382
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e705d-bde7-7041-8e1f-7b0dfdc9cbfc.webp",
  "property_fav_icon_media": {
    "alt_text": "The Aidan logo",
    "public_id": "019e705d-bde7-7041-8e1f-7b0dfdc9cbfc",
    "storage_key": "property/5679206272860160/019e705d-bde7-7041-8e1f-7b0dfdc9cbfc.webp",
    "width": 1382,
    "height": 1382
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e705d-b7ea-77ba-8da8-d67ac712cc35.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Aidan Premier Apartments logo",
    "public_id": "019e705d-b7ea-77ba-8da8-d67ac712cc35",
    "storage_key": "property/5679206272860160/019e705d-b7ea-77ba-8da8-d67ac712cc35.webp",
    "width": 1522,
    "height": 565
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f435c-731d-7042-82b0-9508291b8ba9.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f435c-731d-7042-82b0-9508291b8ba9",
    "storage_key": "property/5679206272860160/019f435c-731d-7042-82b0-9508291b8ba9.webp",
    "width": 1280,
    "height": 475
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#3c6275",
  "property_secondary_color": "#af7350",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#9bb7c6",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "584 - 1231",
  "property_sqft_min": "584",
  "property_sqft_max": "1231",
  "property_price_range": "1314.83 - 2010",
  "property_price_min": "1314.83",
  "property_price_max": "2010",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/TheAidanApartments",
  "property_instagram_url": "https://www.instagram.com/TheAidanApartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJkS_YAo4uTIYRUTPdGaFS5B4",
  "property_youtube_url": "https://www.youtube.com/watch?v=kjEdmpoar2U",
  "property_yelp_url": "https://www.yelp.com/biz/the-aidan-lewisville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Convenience meets resort-style downtime.</strong> At The Aidan, everyday essentials are covered with Parcel Pending package lockers, 24/7 online resident services, controlled-access gates, on-site maintenance, and door-to-door trash pickup. When it’s time to recharge, enjoy the resort-inspired pool and hot tub, 24-hour fitness center with cycling studio, WiFi café with Starbucks coffee bar, outdoor grilling spaces, and a pet play area—all complemented by renovated apartment finishes that bring the comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the space that works your way.</strong> The Aidan offers one, two, and three bedroom apartments in Lewisville with practical layouts, walk-in closets, washer and dryer connections, and private patios or balconies. Select homes elevate the everyday with <strong>granite countertops, tile backsplashes, wood-style flooring, fireplaces, USB outlets, and in-home washers and dryers</strong>—all ready to compare by current pricing and availability.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at The Aidan.</strong> Preview sunny poolside lounge space, a warm clubhouse with wood beams and fireside seating, and apartment interiors with granite countertops, decorative tile, and stainless steel or black appliances. From open living areas to patios and balconies, the gallery captures the details that bring this Lewisville community into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lewisville energy, Flower Mound ease.</strong> The Aidan places you near Old Town Lewisville dining, live music at Wayne Ferguson Plaza, Vista Ridge shopping, and DCTA A-train access toward Denton, Carrollton, and Dallas. For fresh air, Lewisville Lake and LLELA offer trails, paddling, birding, and riverfront scenery just a short drive away. Explore the map to see what’s close.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about life at The Aidan.</strong> Reviews point to the everyday wins: a welcoming office team, helpful maintenance, smooth move-ins, and service requests handled fast. You’ll also see shoutouts for adorable floorplans, upgraded finishes, the Lewisville/Flower Mound location, plus community favorites like the pool, dog park, and included carport space. See why The Aidan earns recommendations from people who know it best.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your everyday rhythm between Lewisville energy and Flower Mound ease.</strong> From The Aidan, you’re close to the local character that makes this part of North Texas feel connected: Historic Old Town Lewisville for Main Street dining, live music at Wayne Ferguson Plaza, and performances at Lewisville Grand Theater; nearby retail and restaurants around Vista Ridge; and DCTA A-train access for trips toward Denton, Carrollton, and Dallas.</p><p>When you want more open air, Lewisville Lake and LLELA bring trails, paddling, birding, and quiet riverfront scenery within an easy drive. Back home, a gated setting with outdoor spaces, a pool, fitness center, and pet-friendly perks keeps the pace convenient. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Aidan fits into the neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday convenience, with room to unwind.</strong> At The Aidan, your amenity mix is designed to make the practical parts simple and the downtime feel effortless. Pick up deliveries from Parcel Pending package lockers, manage needs with 24/7 online resident services, and enjoy controlled-access gates, on-site maintenance, and door-to-door trash pickup.</p><p>When it’s time to reset, head for the resort-inspired pool and hot tub, keep momentum in the 24-hour fitness center with cycling studio, or meet the day in the WiFi café with Starbucks coffee bar. Outdoor grilling spaces, a pet play area, and renovated apartment finishes—granite countertops, tile backsplashes, wood-style flooring, private patios or balconies, and select fireplaces or in-home laundry—bring comfort from the community to your front door. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Aidan home?</strong><br>Start your online application for a newly renovated one, two, or three bedroom apartment with everyday-ready finishes like wood-style flooring, granite countertops, walk-in closets, and private patios or balconies. Review <a href=\"/floor-plans\">available floor plans</a>, then apply with confidence.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact The Aidan leasing team for help with newly renovated one, two, and three bedroom apartments in Lewisville, including layout details, finishes, availability, and how to find us near SH 121 and I-35E.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Aidan?</strong> Start here for quick answers about our newly renovated one, two, and three bedroom apartments, leasing details, community features, and everyday living in Lewisville. If you don’t see what you need, our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you use your space.</strong> The Aidan’s one, two, and three bedroom apartments in Lewisville give you room to choose—from efficient one-bedroom homes with easy flow to larger layouts with extra bedrooms, two-bath options, and space to separate living, dining, work, or storage needs. Each floor plan is designed around everyday function, with walk-in closets, washer and dryer connections, and a private patio or balcony that extends your living area outdoors.</p><p>Inside, select homes add details that make the floor plan feel even more polished: <strong>granite countertops, decorative tile backsplashes, wood-style flooring, fireplaces, USB outlets, and in-home washers and dryers</strong>. Compare current pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which home feels right.</p>",
  "property_gallery_blurb": "<p><strong>See The Aidan before you tour it.</strong> Browse the gallery for a closer look at the textures, light, and everyday spaces that shape this Lewisville apartment community—from a sunny pool deck with lounge seating to a clubhouse framed by warm wood beams, broad windows, and a fireside gathering area.</p><p>Inside the apartments, photos highlight polished kitchens with granite countertops, decorative tile, and stainless steel or black appliances, plus living rooms, bedrooms, and patios or balconies that show how each layout feels in real time. Explore the images, compare the details, then continue with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Aidan on the map.</strong> Find available one, two, and three bedroom apartments, then see how this Lewisville/Flower Mound location connects you to nearby dining, trails, lake recreation, daily essentials, and DFW access.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living that feels easy from the first stroll or sunny nap.</strong> At The Aidan, cats and dogs are welcomed with room for up to two pets and no weight limit, so your home search does not have to shrink around your companion.</p><p>Daily routines are simple here: enjoy the on-site pet play area, take a lap through the gated community, or unwind together on an available private patio or balcony. Door-to-door trash pickup, on-site maintenance, and package lockers help keep the practical side of pet life moving, while nearby off-leash space gives dogs room for a bigger run when the day calls for it. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to picture your next Lewisville apartment with every paw in mind.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at The Aidan?</strong> Share newly renovated apartments, everyday-ready finishes, and easy community extras with a friend. Send an invite today and let them discover one, two, and three bedroom layouts in Lewisville with DFW within reach.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account at The Aidan—so you can get back to enjoying everyday-ready Lewisville living, from your renovated apartment finishes to the community extras just outside your door.</p>",
  "property_reviews_blurb": "<p><strong>Hear directly from people who call The Aidan home.</strong> Reviews highlight the service that stands out most: a welcoming office team, helpful maintenance, and a move-in experience described as smooth and supportive.</p><p>You’ll also see praise for the details that make daily living easier, from “adorable floorplans” and upgraded finishes to fast service requests, a convenient Lewisville/Flower Mound location, and community favorites like the pool, dog park, and included carport space. One reviewer says it simply: “I love my little apartment, the staff and the location.” Browse the latest ratings and see what makes The Aidan a place residents are happy to recommend.</p>",
  "property_created_at": "1752256487982",
  "property_scheduletour_blurb": "<p><strong>See The Aidan in person.</strong> Tour newly renovated one, two, and three bedroom apartments with wood-style flooring, granite countertops, walk-in closets, and private patios or balconies—then explore community spaces like the resort-inspired pool, fitness center, and WiFi café. Schedule your tour today and picture your next Lewisville address.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture life at The Aidan: newly renovated one, two, and three bedroom apartments with stylish finishes, everyday conveniences, and a Lewisville location that keeps DFW within easy reach.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour the spaces that set the scene.</strong> From wherever you are, take a closer look at The Aidan with virtual walkthroughs that bring the community experience into focus. Start with the community tour, then step inside the A2 one-bedroom apartment to see the open living flow, wood-style flooring, crown molding, kitchen peninsula, granite-style surfaces, and natural light that help the layout feel easy to picture.</p><p>When you are ready for a break outdoors, explore the <a href=\"/amenities\">resort-inspired swimming pool with hot tub</a>, complete with a broad deck, lounge seating, umbrellas, mature trees, and a relaxed Lewisville setting. Use these tours to compare details, revisit your favorite angles, and decide what you want to see next—then <a href=\"/schedule-a-tour\">schedule a tour</a> when you are ready to experience The Aidan in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Aidan",
  "property_seo_title_home": "Home | The Aidan",
  "property_seo_description_home": "Elevate your lifestyle at The Aidan in Lewisville, TX! Choose from spacious 1, 2, or 3-bedroom floor plans with luxury amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Lewisville, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Aidan in Lewisville, TX! From cozy one-bedrooms to spacious three-bedrooms, browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Lewisville, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at The Aidan in Lewisville, TX. Enjoy resort-style amenities like a pool, fitness center, and pet play area alongside modern apartment features.",
  "property_seo_title_gallery": "Gallery | Apartments in Lewisville, TX",
  "property_seo_description_gallery": "Picture life at The Aidan in Lewisville, TX! Enjoy spacious floor plans, modern amenities, and vibrant community spaces. Your ideal home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | The Aidan Apartments",
  "property_seo_description_virtualtours": "Experience The Aidan in Lewisville, TX! Dive into our one, two, and three-bedroom apartments with a virtual tour. Your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Aidan Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Aidan in Lewisville, TX! Use our interactive map for apartment options, pricing, and vibrant community amenities designed for you!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lewisville, TX",
  "property_seo_description_neighborhood": "Uncover the vibrant life in Lewisville, TX at The Aidan. Nearby local favorites and attractions await. Find your perfect home and connect with the community!",
  "property_seo_title_contact": "Contact Us | The Aidan",
  "property_seo_description_contact": "Find your perfect home at The Aidan in Lewisville, TX! With one, two, and three-bedroom floor plans, our leasing team is ready to assist you. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Lewisville, TX",
  "property_seo_description_faqs": "Get answers to your burning questions about The Aidan in Lewisville, TX! Learn about our spacious floor plans, amenities, and life in our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lewisville, TX",
  "property_seo_description_reviews": "Experience The Aidan in Lewisville, TX! Check out resident reviews and see why our community's spacious apartments and top-notch amenities make it home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Lewisville, TX",
  "property_seo_description_applynow": "Find your perfect home at The Aidan in Lewisville, TX! Enjoy spacious floor plans, a refreshing pool, fitness center, and pet-friendly amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | The Aidan",
  "property_seo_description_residentaccess": "Experience seamless living at The Aidan! Log in to the resident portal for easy rent payments, maintenance requests, and community updates in Lewisville, TX.",
  "property_seo_title_referafriend": "Refer A Friend | The Aidan",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Aidan in Lewisville, TX, and enjoy the perks of living in a vibrant, welcoming apartment community.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Aidan",
  "property_seo_description_scheduletour": "Experience luxury living at The Aidan in Lewisville, TX. Schedule a tour today and step into your new home filled with modern amenities and vibrant community life!",
  "property_seo_title_privacy": "Privacy Policy | The Aidan",
  "property_seo_description_privacy": "At The Aidan in Lewisville, TX, your privacy matters. Learn about our commitment to safeguarding your information and your peace of mind. View our policy now.",
  "property_seo_title_accessibility": "Website Accessibility | The Aidan",
  "property_seo_description_accessibility": "At The Aidan in Lewisville, TX, we prioritize accessibility for all. Join our inclusive community where everyone can experience vibrant living without barriers.",
  "property_seo_title_sitemap": "Sitemap | The Aidan",
  "property_seo_description_sitemap": "Navigate The Aidan in Lewisville, TX! Find apartment details, amenities, and local highlights easily with our comprehensive sitemap. Your new home awaits!",
  "property_seo_title_thankyou": "Thank You | The Aidan",
  "property_seo_description_thankyou": "Thanks for reaching out to The Aidan! Your submission is received. Our team will connect soon to bring you closer to your new home in Lewisville, TX.",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320345",
  "amenities": [
    {
      "id": "custom_9e2fd74a-b089-4f01-b542-1d8f24e046ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82f88f0f-b853-469c-b172-70d3ccf66a37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4bf701c1-b4a0-46db-b988-ffd7f2b128d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb81844b-9a13-4a63-b258-0362f0d3d814",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a604b8a0-1055-4b57-b66e-7eb9f678d322",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Fireplaces*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_905e2393-0153-42ef-85a7-f3f7459a98bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center & Cycling Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f980aa90-35c9-4e19-a894-d1db14306445",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d22fd527-c76c-4b5d-b3d9-2e9bc919c3d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel or Black Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9e3ee1d-c6c6-4262-ab27-e9a0c2e05bc4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a803fa7-f9cd-40a8-9b7d-24f31b980955",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen w/ BBQ Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5d97cb3c-c2d1-46e8-9279-44fd76095bee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc86fc04-3abc-4660-bf3d-2a4923e517ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/ Hot Tub",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c809c2f2-1c48-4429-a0bc-e4ef750d5ed3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_951dc2bc-3d1f-4a5a-b594-463f17863ad5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000691",
      "title": "Technology Package",
      "amount": "0.0000",
      "description": "Move In Ready Spectrum Cable and Wifi ",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e36c3e47-fa1e-4f82-9572-c81a79b0d45b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4537c9b-3e90-4d7c-a19a-2a8de96acf9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8164ef44-6168-4b82-b6c8-af5f89bea331",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer and Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ea86976-ac4e-4e94-9c54-7bb83b0ad5d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9db45c8d-b35d-4fb4-a3a4-9df15c50863f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "WiFi Cafe w/ Starbucks Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_14dbae1e-4365-44a5-ba34-bb0a29869051",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-d6d5-71ee-b199-1dab531ae4b5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019e89c3-d6d5-71ee-b199-1dab531ae4b5",
        "storage_key": "property/5679206272860160/019e89c3-d6d5-71ee-b199-1dab531ae4b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and refreshing umbrellas, perfect for a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea300dc6-9596-4cee-9913-3c9b3210c9f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-d88c-73dd-8ed3-e26ca09cb866.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and open closet.",
        "public_id": "019e89c3-d88c-73dd-8ed3-e26ca09cb866",
        "storage_key": "property/5679206272860160/019e89c3-d88c-73dd-8ed3-e26ca09cb866.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a king-size bed with accent pillows, a nightstand with a lamp, and a spacious walk-in closet. The room is decorated with modern art and mirrors.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89d01ce8-1800-4ba9-a44d-6ac6865b0584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-d412-75a8-a167-82318a1377b5.webp",
      "image_media": {
        "alt_text": "Spacious living room with fireplace, coffee bar, and ample seating.",
        "public_id": "019e89c3-d412-75a8-a167-82318a1377b5",
        "storage_key": "property/5679206272860160/019e89c3-d412-75a8-a167-82318a1377b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our community's beautifully appointed living room, featuring a cozy fireplace, convenient coffee bar, and comfortable seating areas perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Spacious living room with fireplace, coffee bar, and ample seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e304ad6-582b-472e-823b-d0b1b575c502",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-d76c-775c-91c0-64269099f079.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, stainless steel faucet, and a bathtub with shower.",
        "public_id": "019e89c3-d76c-775c-91c0-64269099f079",
        "storage_key": "property/5679206272860160/019e89c3-d76c-775c-91c0-64269099f079.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bathroom featuring a granite countertop, stainless steel fixtures, and a bathtub/shower combination for your comfort and convenience.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertop, stainless steel faucet, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82470a85-a0ba-4483-9534-b2dead70a9d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-cde8-7618-a65f-e80b5b23be38.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating areas",
        "public_id": "019e89c3-cde8-7618-a65f-e80b5b23be38",
        "storage_key": "property/5679206272860160/019e89c3-cde8-7618-a65f-e80b5b23be38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge seating and a refreshing spa.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating areas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f377fc4-953c-45cc-9818-d9b373b661e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-cf14-77df-8b0f-623b17dc10f8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, teal and orange pillows, and a view of the bathroom.",
        "public_id": "019e89c3-cf14-77df-8b0f-623b17dc10f8",
        "storage_key": "property/5679206272860160/019e89c3-cf14-77df-8b0f-623b17dc10f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this spacious bedroom, featuring a plush king-size bed and elegant decor. The attached bathroom offers modern finishes.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, teal and orange pillows, and a view of the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c48cba6-8713-4075-bfba-edefa9996a41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-cc60-735c-aa9a-16c7729478fb.webp",
      "image_media": {
        "alt_text": "Dining area with a round marble table, four gray chairs, and abstract art on the wall.",
        "public_id": "019e89c3-cc60-735c-aa9a-16c7729478fb",
        "storage_key": "property/5679206272860160/019e89c3-cc60-735c-aa9a-16c7729478fb.webp",
        "width": 2931,
        "height": 1954
      },
      "title": "Apartment",
      "description": "Enjoy your meals in style in this elegant dining area, featuring a marble-top table, comfortable seating, and tasteful wall art. Perfect for intimate dinners or entertaining guests.",
      "link": "",
      "alt_text": "Dining area with a round marble table, four gray chairs, and abstract art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e9c1c03-f9b5-4c76-9e51-8bb09b73f8c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-ccba-73ea-8058-b85acd48f2d3.webp",
      "image_media": {
        "alt_text": "Kitchen island with bar stools, sink, coffee maker, and clock.",
        "public_id": "019e89c3-ccba-73ea-8058-b85acd48f2d3",
        "storage_key": "property/5679206272860160/019e89c3-ccba-73ea-8058-b85acd48f2d3.webp",
        "width": 2681,
        "height": 1787
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee at this stylish kitchen island, complete with bar stools, a coffee maker, and modern fixtures.",
      "link": "",
      "alt_text": "Kitchen island with bar stools, sink, coffee maker, and clock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d44d1fd-4cb8-409f-acc0-e30e07556803",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-ba35-750d-91c9-bb6737324830.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with grills and tables under a wooden pergola, with a pool in the background.",
        "public_id": "019e89c3-ba35-750d-91c9-bb6737324830",
        "storage_key": "property/5679206272860160/019e89c3-ba35-750d-91c9-bb6737324830.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's barbecue grills and shaded dining areas, perfect for social gatherings. Relax by the pool after a delicious meal.",
      "link": "",
      "alt_text": "Outdoor dining area with grills and tables under a wooden pergola, with a pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f12d7f1-e38f-48ff-a0fe-ad8574ed0567",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-ac09-704c-afa0-b572d5785010.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a large window.",
        "public_id": "019e89c3-ac09-704c-afa0-b572d5785010",
        "storage_key": "property/5679206272860160/019e89c3-ac09-704c-afa0-b572d5785010.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting bedroom featuring a comfortable king-size bed, elegant decor, and a large window providing natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c6c3e5c-7dbf-45fc-a793-7d83752e4054",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-b2c7-7008-9bef-a9a4fc8297f8.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment with a table, chairs, and stainless steel appliances.",
        "public_id": "019e89c3-b2c7-7008-9bef-a9a4fc8297f8",
        "storage_key": "property/5679206272860160/019e89c3-b2c7-7008-9bef-a9a4fc8297f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining area connected to a modern kitchen featuring stainless steel appliances, perfect for entertaining.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment with a table, chairs, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5720d0b3-1a21-436d-a3f1-671f912df5ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-b4b2-750f-a23a-9e1e372606a0.webp",
      "image_media": {
        "alt_text": "Stylish living room with a gray sofa, orange accent pillows, and abstract art.",
        "public_id": "019e89c3-b4b2-750f-a23a-9e1e372606a0",
        "storage_key": "property/5679206272860160/019e89c3-b4b2-750f-a23a-9e1e372606a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, featuring a comfortable sofa, elegant decor, and modern artwork.",
      "link": "",
      "alt_text": "Stylish living room with a gray sofa, orange accent pillows, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c935954-c643-4268-b918-fc9ee7285fd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-aeb2-75bc-ba7a-50059275f643.webp",
      "image_media": {
        "alt_text": "Spin room with two stationary bikes, exercise ball, and TV mounted on the wall.",
        "public_id": "019e89c3-aeb2-75bc-ba7a-50059275f643",
        "storage_key": "property/5679206272860160/019e89c3-aeb2-75bc-ba7a-50059275f643.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art spin room, featuring top-of-the-line stationary bikes and everything you need for a great workout.",
      "link": "",
      "alt_text": "Spin room with two stationary bikes, exercise ball, and TV mounted on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4d3b19b7-0e0f-49df-ba9e-298f376662ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-b2d4-702f-9a9b-0df70105ff47.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019e89c3-b2d4-702f-9a9b-0df70105ff47",
        "storage_key": "property/5679206272860160/019e89c3-b2d4-702f-9a9b-0df70105ff47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and soothing hot tub. Lounge chairs and umbrellas are available for your comfort.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c8d3095-cbe7-4546-90c8-41fb0113f7ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-aca7-73b9-8558-f3b851f41ef2.webp",
      "image_media": {
        "alt_text": "Interior view of a spacious apartment complex lobby with vaulted ceilings, exposed wooden beams, and large windows.",
        "public_id": "019e89c3-aca7-73b9-8558-f3b851f41ef2",
        "storage_key": "property/5679206272860160/019e89c3-aca7-73b9-8558-f3b851f41ef2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to our inviting apartment lobby, featuring high vaulted ceilings, exposed wooden beams, and ample natural light streaming through large windows. Relax on the comfortable seating area and enjoy the modern yet cozy atmosphere.",
      "link": "",
      "alt_text": "Interior view of a spacious apartment complex lobby with vaulted ceilings, exposed wooden beams, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1379e79-a075-40da-bd0d-b0b7add65fe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-ac78-7257-be16-2a943a76c2c9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and jacuzzi area with lounge seating and tables in front of apartment buildings.",
        "public_id": "019e89c3-ac78-7257-be16-2a943a76c2c9",
        "storage_key": "property/5679206272860160/019e89c3-ac78-7257-be16-2a943a76c2c9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool and relax in the adjacent jacuzzi. Lounge seating and tables are available for your convenience.",
      "link": "",
      "alt_text": "Outdoor swimming pool and jacuzzi area with lounge seating and tables in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a530aa2-4a8e-4281-aef7-208d2d7e33a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-ad1c-74f4-aff1-5ef3350fc3de.webp",
      "image_media": {
        "alt_text": "Modern living room with vaulted ceilings, fireplace, and large windows.",
        "public_id": "019e89c3-ad1c-74f4-aff1-5ef3350fc3de",
        "storage_key": "property/5679206272860160/019e89c3-ad1c-74f4-aff1-5ef3350fc3de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish community living room featuring a cozy fireplace and ample natural light.",
      "link": "",
      "alt_text": "Modern living room with vaulted ceilings, fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c0726a75-e207-45e1-b5a9-faa15e65a2c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-aca8-734e-b1b8-fd87e853fb3b.webp",
      "image_media": {
        "alt_text": "Spacious living room with a gray sofa, accent chair, dining area, and view of the kitchen.",
        "public_id": "019e89c3-aca8-734e-b1b8-fd87e853fb3b",
        "storage_key": "property/5679206272860160/019e89c3-aca8-734e-b1b8-fd87e853fb3b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern and inviting living space featuring a comfortable gray sofa, stylish accent chair, and a dedicated dining area, perfect for relaxing or entertaining. The open layout seamlessly connects to the kitchen.",
      "link": "",
      "alt_text": "Spacious living room with a gray sofa, accent chair, dining area, and view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c671062-5efb-4de0-8bf9-3edc04f15934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-96d7-7589-aa2b-e58d8d1b3f90.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and cardio equipment.",
        "public_id": "019e89c3-96d7-7589-aa2b-e58d8d1b3f90",
        "storage_key": "property/5679206272860160/019e89c3-96d7-7589-aa2b-e58d8d1b3f90.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of weight machines and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weight machines and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_53f30fb0-a608-471c-8ed9-b6174db7859e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-93b9-75bb-a862-93b8aa1453ee.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and washer/dryer in the background.",
        "public_id": "019e89c3-93b9-75bb-a862-93b8aa1453ee",
        "storage_key": "property/5679206272860160/019e89c3-93b9-75bb-a862-93b8aa1453ee.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this charming kitchen featuring stainless steel appliances, elegant granite countertops, and convenient in-unit laundry facilities. A perfect blend of style and functionality.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and washer/dryer in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b6fbac9-c9e0-4207-a8d0-32bf4fb37c49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-923e-725d-8c26-40120d16540e.webp",
      "image_media": {
        "alt_text": "Closet with shelves, hanging rods, and baskets.",
        "public_id": "019e89c3-923e-725d-8c26-40120d16540e",
        "storage_key": "property/5679206272860160/019e89c3-923e-725d-8c26-40120d16540e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your wardrobe. Includes decorative storage baskets.",
      "link": "",
      "alt_text": "Closet with shelves, hanging rods, and baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f931619f-fd7f-44b6-985d-d32f5ac9e200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-9369-7473-b00d-a9c8da4b20cd.webp",
      "image_media": {
        "alt_text": "Modern coffee bar with a Keurig machine, sink, and bar stools.",
        "public_id": "019e89c3-9369-7473-b00d-a9c8da4b20cd",
        "storage_key": "property/5679206272860160/019e89c3-9369-7473-b00d-a9c8da4b20cd.webp",
        "width": 2996,
        "height": 1997
      },
      "title": "Community",
      "description": "Enjoy a freshly brewed coffee at our stylish coffee bar, complete with a high-end Keurig machine, elegant sink, and comfortable bar seating. A perfect spot to start your day or take a break.",
      "link": "",
      "alt_text": "Modern coffee bar with a Keurig machine, sink, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_10cda1a8-5fc0-4a1a-9ff7-b6450be937c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-966f-715d-bfb0-3e9a07093036.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with pergolas, seating, and grills.",
        "public_id": "019e89c3-966f-715d-bfb0-3e9a07093036",
        "storage_key": "property/5679206272860160/019e89c3-966f-715d-bfb0-3e9a07093036.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining in our community grilling area, featuring a spacious pergola, comfortable seating, and multiple barbecue grills.",
      "link": "",
      "alt_text": "Outdoor grilling area with pergolas, seating, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46944349-0231-46c1-b15e-6dd54eb4faf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-92db-7029-822b-e74b107a7d83.webp",
      "image_media": {
        "alt_text": "The Aidan Premier Apartments package lockers with a digital interface.",
        "public_id": "019e89c3-92db-7029-822b-e74b107a7d83",
        "storage_key": "property/5679206272860160/019e89c3-92db-7029-822b-e74b107a7d83.webp",
        "width": 2934,
        "height": 1956
      },
      "title": "Community",
      "description": "Secure and convenient package lockers for residents at The Aidan Premier Apartments, featuring a digital interface for easy access and management.",
      "link": "",
      "alt_text": "The Aidan Premier Apartments package lockers with a digital interface.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23d4da88-392b-49dd-bd57-1fb4232be728",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-91e3-761c-92cf-8ef2c61e017f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and an outdoor seating area.",
        "public_id": "019e89c3-91e3-761c-92cf-8ef2c61e017f",
        "storage_key": "property/5679206272860160/019e89c3-91e3-761c-92cf-8ef2c61e017f.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "An exterior view of a multi-story apartment building featuring private balconies, well-maintained grounds, and a communal outdoor seating area perfect for relaxation.",
      "link": "",
      "alt_text": "Exterior view of apartment building with balconies and an outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ab10c29-8c86-4f94-878b-2d8127eec3b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-6bef-7626-bcd4-a6962110e325.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and a stationary bike.",
        "public_id": "019e89c3-6bef-7626-bcd4-a6962110e325",
        "storage_key": "property/5679206272860160/019e89c3-6bef-7626-bcd4-a6962110e325.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and weight training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and a stationary bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f181096-d430-4c7c-9595-0bfe6ebe02af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-6ab6-72a8-8786-f63bc364e0e2.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, TV, and decor.",
        "public_id": "019e89c3-6ab6-72a8-8786-f63bc364e0e2",
        "storage_key": "property/5679206272860160/019e89c3-6ab6-72a8-8786-f63bc364e0e2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable couch, stylish coffee table, and mounted TV, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a couch, coffee table, TV, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_4b2a4989e93ff1ffc3375f31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Prairie House Restaurant-Lewisville",
      "poi_type": "Restaurants",
      "poi_address": "119 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Updated steakhouse dining & full bar in a rustic-chic space inside a former feed mill from 1886.",
      "poi_long_description": "Updated steakhouse dining & full bar in a rustic-chic space inside a former feed mill from 1886.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c301-744a-984d-68fa775789fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c301-744a-984d-68fa775789fd",
        "storage_key": "property/5679206272860160/019f14fa-c301-744a-984d-68fa775789fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://phtexaslewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6307053305945780996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-house-restaurant-lewisville",
      "poi_latitude": "33.0466054",
      "poi_longitude": "-96.9932381",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-537-5547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0CAhBEuTIYRBPNZyJAnh1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_11cb110e213c7a37afe34a57",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Main Street Cafe",
      "poi_type": "Restaurants",
      "poi_address": "208 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Easygoing diner serving American breakfast & lunch eats such as omelettes, pancakes & sandwiches.",
      "poi_long_description": "Easygoing diner serving American breakfast & lunch eats such as omelettes, pancakes & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-8d8a-7057-95dc-39438e37845c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8d8a-7057-95dc-39438e37845c",
        "storage_key": "property/5679206272860160/019f14fa-8d8a-7057-95dc-39438e37845c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mainstreetcafe.ai/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9879490166462335097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-cafe",
      "poi_latitude": "33.0460107",
      "poi_longitude": "-96.9924878",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-436-6850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUceXXREuTIYRecjzbfb_Gok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_5ce8d9011e22c987d30f13c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Old Town Wine House",
      "poi_type": "Restaurants",
      "poi_address": "119 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Cozy wine bar offering flights, snacks, and mains, plus a patio and live entertainment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-94e2-7214-b6ca-2f6580899ea8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-94e2-7214-b6ca-2f6580899ea8",
        "storage_key": "property/5679206272860160/019f14fa-94e2-7214-b6ca-2f6580899ea8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oldtownwinehouseandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8869014269694380337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-wine-house",
      "poi_latitude": "33.0464586",
      "poi_longitude": "-96.9947034",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-222-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-545b-7634-8c5a-074607ee1580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-545b-7634-8c5a-074607ee1580",
        "storage_key": "property/5679206272860160/019f14fb-545b-7634-8c5a-074607ee1580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWPYjBEuTIYRMQkB_XwRFXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_1c4c6b2eb8a0a92334bdacc4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "D'Nonna",
      "poi_type": "Restaurants",
      "poi_address": "233 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Casual eatery for pizza chicken dishes and pasta dishes, served amid cozy Italian decor.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-8309-70fe-b12d-4cba8f4e7186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8309-70fe-b12d-4cba8f4e7186",
        "storage_key": "property/5679206272860160/019f14fa-8309-70fe-b12d-4cba8f4e7186.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://dnonnastx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6484643457619944022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dnonna",
      "poi_latitude": "33.0474803",
      "poi_longitude": "-96.9971419",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-240-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0eYviusvTIYRVmJ_Gt4U_lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_8ea684556788f726ad040104",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Sullivan Old Town BBQ",
      "poi_type": "Restaurants",
      "poi_address": "301 S Mill St, Lewisville, TX 75057, USA",
      "poi_short_description": "Homey, old-school eatery offering BBQ meat plates & sandwiches, plus regular live entertainment.",
      "poi_long_description": "Homey, old-school eatery offering BBQ meat plates & sandwiches, plus regular live entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-d0c3-7548-bb18-a53c6b2ea880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d0c3-7548-bb18-a53c6b2ea880",
        "storage_key": "property/5679206272860160/019f14fa-d0c3-7548-bb18-a53c6b2ea880.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sullivanbarbecue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=959519668941873688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivan-old-town-bbq",
      "poi_latitude": "33.0440961",
      "poi_longitude": "-96.9944511",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-451-5599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8DEmw0vTIYRGOJHHg7mUA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_b23e5236c79db64eb60eab45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Starwood Cafe",
      "poi_type": "Restaurants",
      "poi_address": "859 State Hwy 121, Lewisville, TX 75067, USA",
      "poi_short_description": "Casual cafe offering breakfast and lunch options in a comfy setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-87ca-75e1-a734-7ff94ff83c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-87ca-75e1-a734-7ff94ff83c30",
        "storage_key": "property/5679206272860160/019f14fa-87ca-75e1-a734-7ff94ff83c30.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "http://starwoodcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1870936733431184816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starwood-cafe",
      "poi_latitude": "32.99915319999999",
      "poi_longitude": "-96.9615023",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-488-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJchk7C0vTIYRsD1l4Qvn9hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "ec_36998a68ed55ea06b7d9ee33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Jinbeh Japanese Restaurant Lewisville",
      "poi_type": "Restaurants",
      "poi_address": "2440 S Stemmons Fwy #A, Lewisville, TX 75067, USA",
      "poi_short_description": "Member of a local Japanese chain featuring chefs manning hibachi tables, plus a sushi bar.",
      "poi_long_description": "Member of a local Japanese chain featuring chefs manning hibachi tables, plus a sushi bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-d897-71da-90f8-954f8596f84d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d897-71da-90f8-954f8596f84d",
        "storage_key": "property/5679206272860160/019f14fa-d897-71da-90f8-954f8596f84d.webp",
        "width": 1280,
        "height": 891
      },
      "poi_business_url": "http://www.jinbeh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16458370514563619304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jinbeh-japanese-restaurant-lewisville",
      "poi_latitude": "33.0051004",
      "poi_longitude": "-96.9651496",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-488-2224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QboPOIuTIYR6NlTZsjgZ-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_9a0dad7bcc638dde42bcd3f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Ohayo Sushi",
      "poi_type": "Restaurants",
      "poi_address": "2417 S Stemmons Fwy Ste 100, Lewisville, TX 75067, USA",
      "poi_short_description": "Informal sushi restaurant offering all-you-can-eat options and other Japanese dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-9dec-731d-91a7-1734652310c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-9dec-731d-91a7-1734652310c1",
        "storage_key": "property/5679206272860160/019f14fa-9dec-731d-91a7-1734652310c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ohayosushilewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1429871894084597053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohayo-sushi",
      "poi_latitude": "33.0042991",
      "poi_longitude": "-96.9695267",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-315-8666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAW6TYKYvTIYRPTU6cens1xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_19b1a01a951c99dc137c8b30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "2609 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-82ff-717b-9a02-889e231b495c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-82ff-717b-9a02-889e231b495c",
        "storage_key": "property/5679206272860160/019f14fa-82ff-717b-9a02-889e231b495c.webp",
        "width": 1280,
        "height": 620
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/tx/lewisville?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=10495617677568120392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "33.0001063",
      "poi_longitude": "-96.9620762",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-459-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVhtTh4vTIYRSBbCaavsp5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_2391c93b717682e21e51bb54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "722 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-a36b-700a-bcf8-5fdfd8ca93e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a36b-700a-bcf8-5fdfd8ca93e8",
        "storage_key": "property/5679206272860160/019f14fa-a36b-700a-bcf8-5fdfd8ca93e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/tx/lewisville/722-w-main-st?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=406",
      "poi_directions_map_url": "https://maps.google.com/?cid=15188771905086414560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "33.0460624",
      "poi_longitude": "-97.0103657",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-549-4964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-b1xuMtTIYR4N4b-ZJbydI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_5a0034ae7f1efbb07c0bed88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1026 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-9d1a-725a-98c1-9bd026c371a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-9d1a-725a-98c1-9bd026c371a4",
        "storage_key": "property/5679206272860160/019f14fa-9d1a-725a-98c1-9bd026c371a4.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/lewisville/1026-west-main-st.",
      "poi_directions_map_url": "https://maps.google.com/?cid=13576720868029106794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "33.0428527",
      "poi_longitude": "-97.0163962",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-9131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82GrOeYtTIYRagqCabIzarw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_592be0d7afce6ecab8751dd8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "801 State Hwy 121, Lewisville, TX 75067, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-aa7c-7237-9974-dfd2cdb20b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-aa7c-7237-9974-dfd2cdb20b2b",
        "storage_key": "property/5679206272860160/019f14fa-aa7c-7237-9974-dfd2cdb20b2b.webp",
        "width": 1280,
        "height": 1004
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-lewisville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4789109307063384731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "32.9954818",
      "poi_longitude": "-96.966362",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-316-0086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ9PdAeIuTIYRm7oHfopVdkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_77fa110c16b021a6a54d60b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Inlay Burmese Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "500 E Round Grove Rd #315, Lewisville, TX 75067, USA",
      "poi_short_description": "Laid-back spot serving up traditional Burmese dishes from samosas to curries to noodle soup dishes plus seafood items and rice sides.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-acb9-77d8-9453-3b47d4126d6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-acb9-77d8-9453-3b47d4126d6a",
        "storage_key": "property/5679206272860160/019f14fa-acb9-77d8-9453-3b47d4126d6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3635150482113092534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inlay-burmese-kitchen",
      "poi_latitude": "33.0026811",
      "poi_longitude": "-96.9774667",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-513-9695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2pwiz4vTIYRtttwhxqmcjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "burmese_restaurant"
    },
    {
      "id": "ec_3bdbd712960b15fc64c2ba09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Chante Mexican Grill & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "951 W Round Grove Rd #200, Lewisville, TX 75067, USA",
      "poi_short_description": "Mexican eatery serving familiar favorites such as enchiladas and tacos plus a range of margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-b441-724b-b47b-521417b1737d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b441-724b-b47b-521417b1737d",
        "storage_key": "property/5679206272860160/019f14fa-b441-724b-b47b-521417b1737d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chantemexicangrilltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5107239488674644045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chante-mexican-grill--cantina",
      "poi_latitude": "33.0064979",
      "poi_longitude": "-97.0133772",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-293-8098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyte8eMtTIYRTcBMcUGP4EY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_e93376ba94227521008c7cba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Starship Bagel",
      "poi_type": "Restaurants",
      "poi_address": "1108 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-b0c3-716c-ae83-b0f4fb5a1c31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b0c3-716c-ae83-b0f4fb5a1c31",
        "storage_key": "property/5679206272860160/019f14fa-b0c3-716c-ae83-b0f4fb5a1c31.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.starshipbagel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6523622273519629777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starship-bagel",
      "poi_latitude": "33.0408676",
      "poi_longitude": "-97.021586",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-946-9033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43hWmYgtTIYR0bX25eSPiFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_d13656a5c4bc92e0df9213f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1585 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-b3d8-71ed-addb-beb2fbf21315.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b3d8-71ed-addb-beb2fbf21315",
        "storage_key": "property/5679206272860160/019f14fa-b3d8-71ed-addb-beb2fbf21315.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/lewisville/1585-w-main-st/l842",
      "poi_directions_map_url": "https://maps.google.com/?cid=10397881760231869846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.04255",
      "poi_longitude": "-97.03503",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a611-771c-bfed-9b79a0da7ae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a611-771c-bfed-9b79a0da7ae4",
        "storage_key": "property/5679206272860160/019d02f0-a611-771c-bfed-9b79a0da7ae4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1QcwpYtTIYRlk0i316yTJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_b6e33a3e4efd5e2e022ba20a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "4620 State Hwy 121, Lewisville, TX 75056, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-b54e-729b-9f36-e948fcc18e9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b54e-729b-9f36-e948fcc18e9b",
        "storage_key": "property/5679206272860160/019f14fa-b54e-729b-9f36-e948fcc18e9b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/lewisville/castle-hills/035/00599?cid=loc_03500599_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4550331237395997833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "33.0621895",
      "poi_longitude": "-96.8890554",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-535-2479",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a611-771c-bfed-9b79a0da7ae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a611-771c-bfed-9b79a0da7ae4",
        "storage_key": "property/5679206272860160/019d02f0-a611-771c-bfed-9b79a0da7ae4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe559HS4lTIYRiSRa1yYGJj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d11050a872cf13b70a7c56f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "851 State Hwy 121, Lewisville, TX 75067, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c576-73ae-8aa2-f60f3fe6a259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c576-73ae-8aa2-f60f3fe6a259",
        "storage_key": "property/5679206272860160/019f14fa-c576-73ae-8aa2-f60f3fe6a259.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/lewisville-TX-683.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12642300854746916159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "32.9983816",
      "poi_longitude": "-96.963649",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-948-1026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJex4mox8vTIYRP6XORqV5cq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_a3d82fe5820b265b85897702",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "751 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-bbba-77de-87eb-962a52b43a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-bbba-77de-87eb-962a52b43a36",
        "storage_key": "property/5679206272860160/019f14fa-bbba-77de-87eb-962a52b43a36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6381-lewisville-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1709930304533312245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "33.0476391",
      "poi_longitude": "-97.0124306",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-436-6684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh9ooeeMtTIYR9TJiaI3kuhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_6f2609c0dc45a3e2fda7ca83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "725 Hebron Pkwy, Lewisville, TX 75057, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c50b-716f-95ab-f895e8358bce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c50b-716f-95ab-f895e8358bce",
        "storage_key": "property/5679206272860160/019f14fa-c50b-716f-95ab-f895e8358bce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/vista-ridge/1395",
      "poi_directions_map_url": "https://maps.google.com/?cid=10546068746094317387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.0124667",
      "poi_longitude": "-96.9714149",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-459-2605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz7GNvfsuTIYRSw_NK6YpW5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_6d67ee03b7361d2d4e015980",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1099 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c050-74fa-9cfa-6e631fc14ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c050-74fa-9cfa-6e631fc14ffe",
        "storage_key": "property/5679206272860160/019f14fa-c050-74fa-9cfa-6e631fc14ffe.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lewisville-tx-pharmacies/1099-w-main-st-lewisville-tx-75067/storeid=6865?WT.mc_id=LS_GOOGLE_RX_6865",
      "poi_directions_map_url": "https://maps.google.com/?cid=4754155902935122162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.0425905",
      "poi_longitude": "-97.0202272",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-436-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5447-75e5-b3a8-aaeda4427444.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5447-75e5-b3a8-aaeda4427444",
        "storage_key": "property/5679206272860160/019f14fb-5447-75e5-b3a8-aaeda4427444.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5RCo4-gtTIYR8kBG6Zon-kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8b30ac1c43a699388e76c0c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "RaceTrac",
      "poi_type": "Shopping & Retail",
      "poi_address": "375 FM3040, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c11e-75b1-a058-00eb41ba0d14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c11e-75b1-a058-00eb41ba0d14",
        "storage_key": "property/5679206272860160/019f14fa-c11e-75b1-a058-00eb41ba0d14.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.racetrac.com/locations/texas/lewisville/vista-ridge?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11521743107891177802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "racetrac",
      "poi_latitude": "33.0055925",
      "poi_longitude": "-96.9821315",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-829-6334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5469-7024-9474-34e6df2c9758.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5469-7024-9474-34e6df2c9758",
        "storage_key": "property/5679206272860160/019f14fb-5469-7024-9474-34e6df2c9758.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_S9rO0uTIYRSqko00905Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_bfb29a4b7d070046b550d211",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "724 Hebron Pkwy @, Lakeside Cir, Lewisville, TX 75057, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c894-7512-82cd-47480d0088d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c894-7512-82cd-47480d0088d9",
        "storage_key": "property/5679206272860160/019f14fa-c894-7512-82cd-47480d0088d9.webp",
        "width": 1280,
        "height": 954
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/lewisville/724-hebron-parkway-33120?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3402059581431319601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "33.0097493",
      "poi_longitude": "-96.9677248",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-459-5181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5460-772a-b179-5fb236e551ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5460-772a-b179-5fb236e551ff",
        "storage_key": "property/5679206272860160/019f14fb-5460-772a-b179-5fb236e551ff.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJbcgmwPwuTIYRMYztFyqLNi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_e8fd22e8721382a84f1ab1ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "The Vista Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2401 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-d0c2-704f-a22d-63014c95af62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d0c2-704f-a22d-63014c95af62",
        "storage_key": "property/5679206272860160/019f14fa-d0c2-704f-a22d-63014c95af62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thevistacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8660594557472857579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vista-shopping-center",
      "poi_latitude": "33.0022926",
      "poi_longitude": "-96.9717506",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-315-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ40kJKuQuTIYR693ZPd2cMHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_44a5899e5674f185374b49f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1051 N Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c8f8-735e-b08d-f04a6243aa19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c8f8-735e-b08d-f04a6243aa19",
        "storage_key": "property/5679206272860160/019f14fa-c8f8-735e-b08d-f04a6243aa19.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Lewisville/0551?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-551-_-na-_-0-_-0&y_source=1_MTE4NDUxMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3052053629863446820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "33.057476",
      "poi_longitude": "-97.01541",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-353-4412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjd3iE_ktTIYRJMlzG5sSWyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_e8435b6a85b0c51d9c5d5636",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Southridge Elementary School",
      "poi_type": "Education",
      "poi_address": "495 W Corporate Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-ceb6-718a-bc5b-aa3b1f1d25a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ceb6-718a-bc5b-aa3b1f1d25a4",
        "storage_key": "property/5679206272860160/019f14fa-ceb6-718a-bc5b-aa3b1f1d25a4.webp",
        "width": 956,
        "height": 1280
      },
      "poi_business_url": "https://www.lisd.net/Domain/43",
      "poi_directions_map_url": "https://maps.google.com/?cid=15525728723512305899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southridge-elementary-school",
      "poi_latitude": "33.0104413",
      "poi_longitude": "-97.0017984",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-713-5187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQWxY74MuTIYR66gH5AN4dtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c041d2db9bab9600e57761cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Durham Middle School",
      "poi_type": "Education",
      "poi_address": "2075 Edmonds Ln, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-d31a-76ed-917e-729f44c22527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d31a-76ed-917e-729f44c22527",
        "storage_key": "property/5679206272860160/019f14fa-d31a-76ed-917e-729f44c22527.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://durham.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7163770339217704049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "durham-middle-school",
      "poi_latitude": "33.0119057",
      "poi_longitude": "-97.0035722",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-713-5963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJealJL4IuTIYRcQSNESvTamM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_79f4d41dd1f10b95e51344fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lewisville High School",
      "poi_type": "Education",
      "poi_address": "1098 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-d3d6-737f-b929-583bbfb72a3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d3d6-737f-b929-583bbfb72a3b",
        "storage_key": "property/5679206272860160/019f14fa-d3d6-737f-b929-583bbfb72a3b.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://www.lisd.net/lhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217418244982932091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-high-school",
      "poi_latitude": "33.0402359",
      "poi_longitude": "-97.0192205",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-713-5190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMzpudugtTIYRe4L5a92zbbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_7a6a54022af380b7c5bd02fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lewisville ISD Learning Center",
      "poi_type": "Education",
      "poi_address": "1601 Edmonds Ln, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-ddf8-740a-af24-7a8224eeffd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ddf8-740a-af24-7a8224eeffd5",
        "storage_key": "property/5679206272860160/019f14fa-ddf8-740a-af24-7a8224eeffd5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lisd.net/llc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8324653990693874453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-isd-learning-center",
      "poi_latitude": "33.025044",
      "poi_longitude": "-97.0096602",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-713-5185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJca0uU9YtTIYRFatY2bIch3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_66197f7453b1057c161a889a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "TECC West (Lewisville ISD)",
      "poi_type": "Education",
      "poi_address": "1250A W Round Grove Rd, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-e1df-761f-856e-e8d7bcaa160a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e1df-761f-856e-e8d7bcaa160a",
        "storage_key": "property/5679206272860160/019f14fa-e1df-761f-856e-e8d7bcaa160a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.lisd.net/teccw",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748455843882665446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tecc-west-lewisville-isd",
      "poi_latitude": "33.0060772",
      "poi_longitude": "-97.0226371",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-713-5186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMag47LYtTIYR5gWlJSKexk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_a1bdb728750f794cd214e083",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lillie J. Jackson Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "1651 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lisd.net/Domain/33",
      "poi_directions_map_url": "https://maps.google.com/?cid=15770334045110795699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lillie-j-jackson-early-childhood-center",
      "poi_latitude": "33.0266121",
      "poi_longitude": "-97.0178153",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-713-5986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0WSAFdAtTIYRs_0TXEJ729o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_392b72e2682e40c74385ca4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "OurKids Montessori School & Child Care Center",
      "poi_type": "Education",
      "poi_address": "477 Highland Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "Childcare center and Montessori school providing education for infants, toddlers, and preschoolers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-dba7-725a-abea-ddf4ec7903e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-dba7-725a-abea-ddf4ec7903e0",
        "storage_key": "property/5679206272860160/019f14fa-dba7-725a-abea-ddf4ec7903e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ourkidsmontessori.com/contact-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7159800906016463611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ourkids-montessori-school--child-care-center",
      "poi_latitude": "32.9945232",
      "poi_longitude": "-96.9782294",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-318-2932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvfO-RcIuTIYR-5qhYf24XGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_44558ae7446e45e99f0e7920",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Enlighten Academy",
      "poi_type": "Education",
      "poi_address": "297 W Round Grove Rd #230, Lewisville, TX 75067, USA",
      "poi_short_description": "Clean institution featuring daycare and after-school programs such as STEM, art and language classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-db32-742e-a536-94a5275e09a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-db32-742e-a536-94a5275e09a7",
        "storage_key": "property/5679206272860160/019f14fa-db32-742e-a536-94a5275e09a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.enlightenacademycoppell.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=474155199634012403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enlighten-academy",
      "poi_latitude": "33.0039261",
      "poi_longitude": "-96.9965814",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-630-0002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8_azi5ouTIYR8_iWUqSJlAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_785b763f911e941f4ea7a462",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Sunshine Daycare",
      "poi_type": "Education",
      "poi_address": "223 Oakwood Ln, Lewisville, TX 75067, USA",
      "poi_short_description": "Daycare and preschool facility offering Montessori-based education.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-e12a-74f8-be01-b6352e5cca88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e12a-74f8-be01-b6352e5cca88",
        "storage_key": "property/5679206272860160/019f14fa-e12a-74f8-be01-b6352e5cca88.webp",
        "width": 810,
        "height": 1080
      },
      "poi_business_url": "https://thesunshinedaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16488213909085528048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-daycare",
      "poi_latitude": "33.0282596",
      "poi_longitude": "-96.9967127",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-219-5522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk47oxQsvTIYR8J-yJzHn0eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_907b964280f6b32f7b1d1a43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Founders Classical Academy of Lewisville",
      "poi_type": "Education",
      "poi_address": "1010 Bellaire Blvd, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-e68b-770b-a8e9-fb1517e4aa96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e68b-770b-a8e9-fb1517e4aa96",
        "storage_key": "property/5679206272860160/019f14fa-e68b-770b-a8e9-fb1517e4aa96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://foundersclassical.com/lewisville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10934055765549843767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "founders-classical-academy-of-lewisville",
      "poi_latitude": "33.0273403",
      "poi_longitude": "-97.0166246",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-464-3415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaZwPXNAtTIYRNwXpo8mRvZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_290e2c062eac062d568f09da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Cinemark Lewisville and XD",
      "poi_type": "Entertainment",
      "poi_address": "2401 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-e064-703c-bd1b-549483abca6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e064-703c-bd1b-549483abca6d",
        "storage_key": "property/5679206272860160/019f14fa-e064-703c-bd1b-549483abca6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-lewisville/cinemark-lewisville-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5NTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5421992385327197290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-lewisville-and-xd",
      "poi_latitude": "33.0015458",
      "poi_longitude": "-96.9707528",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-315-6152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-545c-7127-a47e-1d6853989ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-545c-7127-a47e-1d6853989ba1",
        "storage_key": "property/5679206272860160/019f14fb-545c-7127-a47e-1d6853989ba1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwew-uMuTIYRauxM9ljJPks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_131cf0e0c853791a6846d658",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lewisville Grand Theater",
      "poi_type": "Entertainment",
      "poi_address": "100 N Charles St, Lewisville, TX 75057, USA",
      "poi_short_description": "Spacious, contemporary venue featuring theater performances, events & classes, plus an art gallery.",
      "poi_long_description": "Spacious, contemporary venue featuring theater performances, events & classes, plus an art gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-e568-768e-933a-da45fd42105d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e568-768e-933a-da45fd42105d",
        "storage_key": "property/5679206272860160/019f14fa-e568-768e-933a-da45fd42105d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lewisvillegrand.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9286174857949251761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-grand-theater",
      "poi_latitude": "33.0467948",
      "poi_longitude": "-96.9972686",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-8446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaEPBA4uTIYRsYg6QtUe34A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ceace0be4762779c0ac204e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Buffalo Hirsch",
      "poi_type": "Entertainment",
      "poi_address": "206 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-fd49-708f-b364-912783997935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-fd49-708f-b364-912783997935",
        "storage_key": "property/5679206272860160/019f14fa-fd49-708f-b364-912783997935.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://buffalohirsch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12524649682853331709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-hirsch",
      "poi_latitude": "33.0460489",
      "poi_longitude": "-96.9968395",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-745-2917",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-545b-7634-8c5a-074607ee1580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-545b-7634-8c5a-074607ee1580",
        "storage_key": "property/5679206272860160/019f14fb-545b-7634-8c5a-074607ee1580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO-EAqU4vTIYR_YKuMod-0K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_5d29ade6bdcba6c4c510a7e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "BENDT Distilling Co.",
      "poi_type": "Entertainment",
      "poi_address": "225 S Charles St, Lewisville, TX 75057, USA",
      "poi_short_description": "Stylish distillery featuring handcrafted whiskies, guided tours, a craft cocktail bar & live music.",
      "poi_long_description": "Stylish distillery featuring handcrafted whiskies, guided tours, a craft cocktail bar & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-ee6c-741b-ab93-f8c46fc73b04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ee6c-741b-ab93-f8c46fc73b04",
        "storage_key": "property/5679206272860160/019f14fa-ee6c-741b-ab93-f8c46fc73b04.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bendtdistillingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11360244417594972231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bendt-distilling-co",
      "poi_latitude": "33.0447239",
      "poi_longitude": "-96.9972219",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-814-0545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66d6GgYuTIYRR9hc0Buyp50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_edd8335741692b9d7f37579e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "LLELA Nature Preserve",
      "poi_type": "Entertainment",
      "poi_address": "201 E Jones St, Lewisville, TX 75057, USA",
      "poi_short_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_long_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-f83f-77fa-9784-fa6b62a06d15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f83f-77fa-9784-fa6b62a06d15",
        "storage_key": "property/5679206272860160/019f14fa-f83f-77fa-9784-fa6b62a06d15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.llela.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336426955797826332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "llela-nature-preserve",
      "poi_latitude": "33.0638972",
      "poi_longitude": "-96.9922426",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7_GUP8xTIYRHAt-2kAUU50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_fc173383c1295fed14c0802b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Chuck E. Cheese",
      "poi_type": "Entertainment",
      "poi_address": "2402 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_long_description": "Kid-friendly chain known for its arcade games, pizza parties & play zones.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-f186-778b-84a7-2932b0f24f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f186-778b-84a7-2932b0f24f47",
        "storage_key": "property/5679206272860160/019f14fa-f186-778b-84a7-2932b0f24f47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chuckecheese.com/lewisville-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10091800533329076479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuck-e-cheese",
      "poi_latitude": "33.0071445",
      "poi_longitude": "-96.9707776",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-315-6260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZEg6-QuTIYR_2AtzR1HDYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_c428f92152403e3c331701f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Andretti Indoor Karting & Games The Colony",
      "poi_type": "Entertainment",
      "poi_address": "5752 Grandscape Blvd Ste 100, The Colony, TX 75056, USA",
      "poi_short_description": "Arcade featuring go-karts, bowling and laser tag, plus a track for electric superkarts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-f70f-718e-94b0-d403c1c893b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f70f-718e-94b0-d403c1c893b9",
        "storage_key": "property/5679206272860160/019f14fa-f70f-718e-94b0-d403c1c893b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://andrettikarting.com/thecolony/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8539956745447602546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-the-colony",
      "poi_latitude": "33.0742492",
      "poi_longitude": "-96.8611526",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-527-3278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzZVK6A7TIYRcvma0WkFhHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_cd2fb6390c4cfec485c3bae8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Topgolf The Colony",
      "poi_type": "Entertainment",
      "poi_address": "3760 Blair Oaks Dr, The Colony, TX 75056, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-f254-754c-a13c-714a513f40b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f254-754c-a13c-714a513f40b4",
        "storage_key": "property/5679206272860160/019f14fa-f254-754c-a13c-714a513f40b4.webp",
        "width": 980,
        "height": 653
      },
      "poi_business_url": "https://topgolf.com/us/the-colony/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12559740388646950382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-the-colony",
      "poi_latitude": "33.0703613",
      "poi_longitude": "-96.8837492",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-213-5204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a608-73a7-86dd-2ed18140ec8c",
        "storage_key": "property/5679206272860160/019d02f0-a608-73a7-86dd-2ed18140ec8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbpTPNM6TIYR7pVt0FYpTa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_45e37db98b77b326b9e2dbb3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "4Thirteen Kitchen and Sports Lounge",
      "poi_type": "Entertainment",
      "poi_address": "755 State Hwy 121 BYP, Lewisville, TX 75067, USA",
      "poi_short_description": "Cozy sports bar known for soul food, beer, and live entertainment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-fedb-71d9-9ad1-5d9cfad04922.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-fedb-71d9-9ad1-5d9cfad04922",
        "storage_key": "property/5679206272860160/019f14fa-fedb-71d9-9ad1-5d9cfad04922.webp",
        "width": 1280,
        "height": 799
      },
      "poi_business_url": "http://4thirteendallas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14831645062759002557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "4thirteen-kitchen-and-sports-lounge",
      "poi_latitude": "32.9954927",
      "poi_longitude": "-96.9673839",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-464-3857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-545b-7634-8c5a-074607ee1580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-545b-7634-8c5a-074607ee1580",
        "storage_key": "property/5679206272860160/019f14fb-545b-7634-8c5a-074607ee1580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYeQ0L2UvTIYRvTFtaJqW1M0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_5f784a1c9c0c73c6114f33b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Wayne Ferguson Plaza",
      "poi_type": "Entertainment",
      "poi_address": "150 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Relaxed gathering spot for festivals and concerts in the summer and free fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-f947-76bd-a4bc-83801a9b1c91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f947-76bd-a4bc-83801a9b1c91",
        "storage_key": "property/5679206272860160/019f14fa-f947-76bd-a4bc-83801a9b1c91.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/wayne-ferguson-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=15692859072330310905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayne-ferguson-plaza",
      "poi_latitude": "33.0471824",
      "poi_longitude": "-96.9956036",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-219-3401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-gW5BEuTIYR-aSDlC48yNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_c75a671098df2817aa5ba378",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Medical City Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-89ba-77ee-883b-d91dd446e3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f0-89ba-77ee-883b-d91dd446e3e9",
        "storage_key": "property/5679206272860160/019d02f0-89ba-77ee-883b-d91dd446e3e9.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-lewisville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514616797377254311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-lewisville",
      "poi_latitude": "33.0454235",
      "poi_longitude": "-97.0049828",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-370-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a9b1-71ab-aee3-39f9baf8a898.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a9b1-71ab-aee3-39f9baf8a898",
        "storage_key": "property/5679206272860160/019d02f0-a9b1-71ab-aee3-39f9baf8a898.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-CoNgouTIYRp9Pmeae25SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_581c7f7ead596b0d9c2f6be8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "1559 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-fc77-7115-9587-d4551f80c0bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-fc77-7115-9587-d4551f80c0bd",
        "storage_key": "property/5679206272860160/019f14fa-fc77-7115-9587-d4551f80c0bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/lewisville?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11104618521802294127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---lewisville",
      "poi_latitude": "33.0426704",
      "poi_longitude": "-97.0313202",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-436-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Rz9l5YtTIYRb8M_9rWHG5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_07928130baa0e8c9fa65c969",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Baylor Scott & White Urgent Care+ Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "540 Surf St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-00be-7298-96c8-4d7c2b9f201d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-00be-7298-96c8-4d7c2b9f201d",
        "storage_key": "property/5679206272860160/019f14fb-00be-7298-96c8-4d7c2b9f201d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bswhealth.com/locations/urgent-care/uc-plus-lewisville?utm_source=google-mybusiness&utm_medium=organic&utm_campaign=UC+Lewisville&utm_content=main-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=6204775221569807245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care-lewisville",
      "poi_latitude": "33.0439583",
      "poi_longitude": "-97.0144103",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-420-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfW9juYtTIYRjWPQkDDKG1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_9d417a27b2246477345df5f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1099 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-c050-74fa-9cfa-6e631fc14ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c050-74fa-9cfa-6e631fc14ffe",
        "storage_key": "property/5679206272860160/019f14fa-c050-74fa-9cfa-6e631fc14ffe.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lewisville-tx-pharmacies/1099-w-main-st-lewisville-tx-75067/storeid=6865?WT.mc_id=LS_GOOGLE_RX_6865",
      "poi_directions_map_url": "https://maps.google.com/?cid=4754155902935122162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.0425905",
      "poi_longitude": "-97.0202272",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-436-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5447-75e5-b3a8-aaeda4427444.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5447-75e5-b3a8-aaeda4427444",
        "storage_key": "property/5679206272860160/019f14fb-5447-75e5-b3a8-aaeda4427444.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5RCo4-gtTIYR8kBG6Zon-kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_86aac6e38b70ac3c7d31d08c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1103 FM3040, Lewisville, TX 75067, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-0aef-74ce-8bf1-cfc10f112fc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0aef-74ce-8bf1-cfc10f112fc3",
        "storage_key": "property/5679206272860160/019f14fb-0aef-74ce-8bf1-cfc10f112fc3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1103+w+round+grove+rd-lewisville-tx-75067/id=5960",
      "poi_directions_map_url": "https://maps.google.com/?cid=13285167060475715721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.0066963",
      "poi_longitude": "-97.0198397",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-488-8680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UyEbTAsTIYRiSBgvQ1lXrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_6dd831b0fc7a1889ea25c8d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "801 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-0443-71d6-b6c5-3deb17dae346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0443-71d6-b6c5-3deb17dae346",
        "storage_key": "property/5679206272860160/019f14fb-0443-71d6-b6c5-3deb17dae346.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/217-lewisville-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101684157502184564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "33.0471863",
      "poi_longitude": "-97.0140609",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-221-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5447-75e5-b3a8-aaeda4427444.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5447-75e5-b3a8-aaeda4427444",
        "storage_key": "property/5679206272860160/019f14fb-5447-75e5-b3a8-aaeda4427444.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_iUT-QtTIYRdNyr_gY_s8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_41ae7f002386a95c666f5e4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "798 E Vista Ridge Mall Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain health club offering cardio and strength equipment, plus group classes, and pools.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-8392-7628-9fb0-97aa98a331ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f0-8392-7628-9fb0-97aa98a331ab",
        "storage_key": "property/5679206272860160/019d02f0-8392-7628-9fb0-97aa98a331ab.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=334&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12745807886122409510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.0005792",
      "poi_longitude": "-96.9650374",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-315-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt5FFyOEuTIYRJt6yA7404rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a390c8b732b75fcfc6fd3d1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "500 E Round Grove Rd #201, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, massage chairs, and tanning beds in a welcoming setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14f8-602c-724b-a128-4508514c22ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-602c-724b-a128-4508514c22ad",
        "storage_key": "property/5679206272860160/019f14f8-602c-724b-a128-4508514c22ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/lewisville-round-grove-rd-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15866743250462238426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.0030498",
      "poi_longitude": "-96.9765312",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-293-2215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpYXxAXAuTIYR2uYgsuv-Mdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f63cf86653cf4cd03a85efb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Fit Appeal Studios | Fitness Nutrition Yoga Pilates Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "817 S Mill St #110, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-0c19-75eb-bea1-10764896f292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0c19-75eb-bea1-10764896f292",
        "storage_key": "property/5679206272860160/019f14fb-0c19-75eb-bea1-10764896f292.webp",
        "width": 1171,
        "height": 659
      },
      "poi_business_url": "https://www.fit-appeal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10383249150759462355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-appeal-studios--fitness-nutrition-yoga-pilates-lewisville",
      "poi_latitude": "33.0381315",
      "poi_longitude": "-96.9932532",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-312-0657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58E5_GwuTIYR0-Vk_Ra2GJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_4c870863a231ff43f41bd4de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Blue Anjou Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "427 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Cozy yoga studio offering a variety of classes and teacher training programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-09de-73ba-a413-8f17534e1ae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-09de-73ba-a413-8f17534e1ae1",
        "storage_key": "property/5679206272860160/019f14fb-09de-73ba-a413-8f17534e1ae1.webp",
        "width": 864,
        "height": 473
      },
      "poi_business_url": "http://www.blueanjou.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912147855743026414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-anjou-yoga-studio",
      "poi_latitude": "33.0465534",
      "poi_longitude": "-97.0022612",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-645-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEXbfRQkuTIYR7oRG3MPgEcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_6756c3004a7ce25aa4476c57",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Oakbend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-1440-7751-8d29-eaa791d3c37c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1440-7751-8d29-eaa791d3c37c",
        "storage_key": "property/5679206272860160/019f14fb-1440-7751-8d29-eaa791d3c37c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.playlewisville.com/Home/Components/FacilityDirectory/FacilityDirectory/106/3144?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=2012225660542047023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakbend-park",
      "poi_latitude": "33.008951",
      "poi_longitude": "-96.988249",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRjFpo0uTIYRL9OIuJPc7Bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ad2b8b9969246b6c4911143b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Iris Lane Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-1056-7194-9570-facead8dba24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1056-7194-9570-facead8dba24",
        "storage_key": "property/5679206272860160/019f14fb-1056-7194-9570-facead8dba24.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/iris-lane-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1727730271802082336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iris-lane-park",
      "poi_latitude": "33.0383869",
      "poi_longitude": "-97.0277892",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVeqX220tTIYRIMRzPoch-hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2347bf1837dd19edcfccde45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1899 Edmonds Ln, Lewisville, TX 75067, USA",
      "poi_short_description": "Community gathering spot with a mile-long hike-&-bike trail, a bandshell & picnic pavilions.",
      "poi_long_description": "Community gathering spot with a mile-long hike-&-bike trail, a bandshell & picnic pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-0dad-7588-ab3e-b37e1940bdf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0dad-7588-ab3e-b37e1940bdf8",
        "storage_key": "property/5679206272860160/019f14fb-0dad-7588-ab3e-b37e1940bdf8.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/central-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6137018537875316772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "33.0175287",
      "poi_longitude": "-97.0053478",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn73sUXwuTIYRJKALStgRK1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_02169a8439dfd4517e50456c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1950 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "City park popular with families boasting 3 playgrounds, trails & an indoor recreation center.",
      "poi_long_description": "City park popular with families boasting 3 playgrounds, trails & an indoor recreation center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-1d07-7309-a017-2480ec917711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1d07-7309-a017-2480ec917711",
        "storage_key": "property/5679206272860160/019f14fb-1d07-7309-a017-2480ec917711.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4616919215009787604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "33.0192055",
      "poi_longitude": "-97.0217463",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB97j-cwtTIYR1G5Vh5CXEkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_12a4cb613cb3ebe13e5d51ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Thrive Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1951 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-1cfa-7659-884e-8e4bfe4864a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1cfa-7659-884e-8e4bfe4864a9",
        "storage_key": "property/5679206272860160/019f14fb-1cfa-7659-884e-8e4bfe4864a9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/thrive-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14523521086535438241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thrive-nature-park",
      "poi_latitude": "33.0184243",
      "poi_longitude": "-97.0189401",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ywsZX8tTIYRoQ_Xsnrpjck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e267d3d9ca152a4d8f68d0eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Raldon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 Foxwood Pl, Lewisville, TX 75067, USA",
      "poi_short_description": "Well-maintained park featuring a basketball court and a playground for children, plus a path for walking and biking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-0f4d-759f-82e3-d919bcc638f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0f4d-759f-82e3-d919bcc638f6",
        "storage_key": "property/5679206272860160/019f14fb-0f4d-759f-82e3-d919bcc638f6.webp",
        "width": 720,
        "height": 706
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/raldon-lake-cities-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13226675434266148052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raldon-park",
      "poi_latitude": "33.031084",
      "poi_longitude": "-97.0029838",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bMfGXcuTIYR1LzRwjqXjrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_bf4a6f5437098845d4b1c7b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lone Star Toyota of Lewisville",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1547 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Car dealership selling new and used Toyota models, along with servicing existing cars.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-27c4-736b-abc8-dd05c7a71616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-27c4-736b-abc8-dd05c7a71616",
        "storage_key": "property/5679206272860160/019f14fb-27c4-736b-abc8-dd05c7a71616.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lonestartoyotalewisville.com/?utm_source=google&utm_medium=organic&utm_campaign=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161783381790417593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-toyota-of-lewisville",
      "poi_latitude": "33.021379",
      "poi_longitude": "-96.987898",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-671-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd1u_WWAuTIYRueKF1lYNg1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_dealer"
    },
    {
      "id": "ec_2494b6d4e25c8649758db05e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Wayne Frady Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "535 W College St, Lewisville, TX 75057, USA",
      "poi_short_description": "Clean aquatic park featuring a splash pad, a playground and picnic tables/benches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-2011-72e1-81f4-91e6c12f6890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-2011-72e1-81f4-91e6c12f6890",
        "storage_key": "property/5679206272860160/019f14fb-2011-72e1-81f4-91e6c12f6890.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/wayne-frady-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8446916109864652940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayne-frady-park",
      "poi_latitude": "33.0496347",
      "poi_longitude": "-97.0049005",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUrGcwguTIYRjNABwHJ5OXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_a78681dc104fad2e07e08044",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "LLELA Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Jones St, Lewisville, TX 75057, USA",
      "poi_short_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_long_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-f83f-77fa-9784-fa6b62a06d15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f83f-77fa-9784-fa6b62a06d15",
        "storage_key": "property/5679206272860160/019f14fa-f83f-77fa-9784-fa6b62a06d15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.llela.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336426955797826332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "llela-nature-preserve",
      "poi_latitude": "33.0638972",
      "poi_longitude": "-96.9922426",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7_GUP8xTIYRHAt-2kAUU50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_31355ef82616ee6be933e467",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Sandy Beach Rd, Lewisville, TX 75057, USA",
      "poi_short_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_long_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-2445-702d-a2d5-4fb01e60b6c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-2445-702d-a2d5-4fb01e60b6c1",
        "storage_key": "property/5679206272860160/019f14fb-2445-702d-a2d5-4fb01e60b6c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3830431707728878479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-park",
      "poi_latitude": "33.0770484",
      "poi_longitude": "-97.0066054",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a990-7605-af8c-2f32b31a5aac",
        "storage_key": "property/5679206272860160/019d02f0-a990-7605-af8c-2f32b31a5aac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNevF6_cxTIYRj5uS-1dtKDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_bc5a1699915d86428fcad602",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Old Town",
      "poi_type": "Transportation & Transit",
      "poi_address": "617 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-9675-776f-9fca-7dd1745e3692.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f0-9675-776f-9fca-7dd1745e3692",
        "storage_key": "property/5679206272860160/019d02f0-9675-776f-9fca-7dd1745e3692.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239306256237320260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town",
      "poi_latitude": "33.04736330000001",
      "poi_longitude": "-96.9863475",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-ac85-724b-bbb6-da52dfc2ab5b",
        "storage_key": "property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwu6ERYuTIYRRNhJP68ud2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_8153e5644fcf3392f0df4ec2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Hebron Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "952 Lakeside Cir, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-98cb-779b-9d26-0ae795762dbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f0-98cb-779b-9d26-0ae795762dbb",
        "storage_key": "property/5679206272860160/019d02f0-98cb-779b-9d26-0ae795762dbb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dcta.net/images/uploads/content_files/connect_files/1-15-update/route21-1-15.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216114618958893695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hebron-station",
      "poi_latitude": "33.0101482",
      "poi_longitude": "-96.9584227",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-ac85-724b-bbb6-da52dfc2ab5b",
        "storage_key": "property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJby-eZwMvTIYRf1Iowk8TRFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_6d37acbf846688c88891ed44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Highland Village/Lewisville Lake Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2998 N Stemmons Fwy, Lewisville, TX 75077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14f8-7851-7666-b8c1-eba0967e65bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-7851-7666-b8c1-eba0967e65bf",
        "storage_key": "property/5679206272860160/019f14f8-7851-7666-b8c1-eba0967e65bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7343931499598697122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-villagelewisville-lake-station",
      "poi_latitude": "33.0834155",
      "poi_longitude": "-97.0259929",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-ac85-724b-bbb6-da52dfc2ab5b",
        "storage_key": "property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5AgfhUyTIYRotJhAMri6mU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_7e5006b0334a43464e871597",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Trinity Mills",
      "poi_type": "Transportation & Transit",
      "poi_address": "2525 Blanton Dr, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14f8-73ac-73b6-a945-b62d8506093a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-73ac-73b6-a945-b62d8506093a",
        "storage_key": "property/5679206272860160/019f14f8-73ac-73b6-a945-b62d8506093a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/trinitymillsstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=777499669808973001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-mills",
      "poi_latitude": "32.98092",
      "poi_longitude": "-96.9264",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-ac85-724b-bbb6-da52dfc2ab5b",
        "storage_key": "property/5679206272860160/019d02f0-ac85-724b-bbb6-da52dfc2ab5b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbbbi1MvTIYRyYTyj9Q7ygo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_503d9fc7c89381a41e5d9f86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Downtown Denton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "604 E Hickory St, Denton, TX 76205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-33f1-7669-9372-9751a5dcb951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-33f1-7669-9372-9751a5dcb951",
        "storage_key": "property/5679206272860160/019f14fb-33f1-7669-9372-9751a5dcb951.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12243141428338983573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-denton-transit-center",
      "poi_latitude": "33.213705",
      "poi_longitude": "-97.126051",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a978-7606-838b-a9ed12397c06",
        "storage_key": "property/5679206272860160/019d02f0-a978-7606-838b-a9ed12397c06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_P6Z43KTYYRlYIDG0Ng6Kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_c84d8435978562c3d605a59c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "MedPark Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3220 Medpark Dr, Denton, TX 76210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-37c8-72c8-a56f-090ec8834fa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-37c8-72c8-a56f-090ec8834fa1",
        "storage_key": "property/5679206272860160/019f14fb-37c8-72c8-a56f-090ec8834fa1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.dcta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6211726032118505052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medpark-station",
      "poi_latitude": "33.1820209",
      "poi_longitude": "-97.0914304",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 940-243-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5478-77dc-8020-8605ceb40020.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5478-77dc-8020-8605ceb40020",
        "storage_key": "property/5679206272860160/019f14fb-5478-77dc-8020-8605ceb40020.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJKx2N0dI0TIYRXF54Qup7NFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_76f5122b0f5fcb98ff95e19e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Denton County Transportation Auth",
      "poi_type": "Transportation & Transit",
      "poi_address": "1955 Lakeway Dr #260, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-3899-763d-ad89-9c0f8c5df366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3899-763d-ad89-9c0f8c5df366",
        "storage_key": "property/5679206272860160/019f14fb-3899-763d-ad89-9c0f8c5df366.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dcta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16185488412502635099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denton-county-transportation-auth",
      "poi_latitude": "33.0175586",
      "poi_longitude": "-96.9742102",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 940-243-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5473-747f-88f5-289114d37777",
        "storage_key": "property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTtSwF8uTIYRW7Jr7_RnnuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_6dcee1154beb5e8f5fda9cf4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-3c2f-7087-8f69-28cf717acb16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3c2f-7087-8f69-28cf717acb16",
        "storage_key": "property/5679206272860160/019f14fb-3c2f-7087-8f69-28cf717acb16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "5 hours 6 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-54b2-726e-82c6-d7e16c9cdbe7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-54b2-726e-82c6-d7e16c9cdbe7",
        "storage_key": "property/5679206272860160/019f14fb-54b2-726e-82c6-d7e16c9cdbe7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_602af744a030622dc3155dfb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Medical City Lewisville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-89ba-77ee-883b-d91dd446e3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f0-89ba-77ee-883b-d91dd446e3e9",
        "storage_key": "property/5679206272860160/019d02f0-89ba-77ee-883b-d91dd446e3e9.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-lewisville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514616797377254311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-lewisville",
      "poi_latitude": "33.0454235",
      "poi_longitude": "-97.0049828",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-370-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a9b1-71ab-aee3-39f9baf8a898.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a9b1-71ab-aee3-39f9baf8a898",
        "storage_key": "property/5679206272860160/019d02f0-a9b1-71ab-aee3-39f9baf8a898.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-CoNgouTIYRp9Pmeae25SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_57fee213c8f1a1d8b54d5bfe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Texas Health Presbyterian Hospital Flower Mound",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 Long Prairie Rd, Flower Mound, TX 75028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-8b05-72ad-8ee6-08ccb236e409.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f0-8b05-72ad-8ee6-08ccb236e409",
        "storage_key": "property/5679206272860160/019d02f0-8b05-72ad-8ee6-08ccb236e409.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-flower-mound",
      "poi_directions_map_url": "https://maps.google.com/?cid=10658615510840280430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-presbyterian-hospital-flower-mound",
      "poi_latitude": "33.0456181",
      "poi_longitude": "-97.0676197",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-322-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a9b1-71ab-aee3-39f9baf8a898.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a9b1-71ab-aee3-39f9baf8a898",
        "storage_key": "property/5679206272860160/019d02f0-a9b1-71ab-aee3-39f9baf8a898.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6RXXWgtTIYRboUa2VUC65M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a0021399561f7d67e507aadd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lewisville Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1565 W Main St #220, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-3e83-75c2-8a80-a6e595c2d767.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3e83-75c2-8a80-a6e595c2d767",
        "storage_key": "property/5679206272860160/019f14fb-3e83-75c2-8a80-a6e595c2d767.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14983067533701921762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-independent-school-district",
      "poi_latitude": "33.0440774",
      "poi_longitude": "-97.035263",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-713-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_7CoNZEtTIYR4rv9x4mM7s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e9f2d51a166d911ec6204c04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Lewisville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "151 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-33dd-75c3-8f2e-a73ffb0eeb20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-33dd-75c3-8f2e-a73ffb0eeb20",
        "storage_key": "property/5679206272860160/019f14fb-33dd-75c3-8f2e-a73ffb0eeb20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoflewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720423613431398683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-city-hall",
      "poi_latitude": "33.0478003",
      "poi_longitude": "-96.9953369",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-219-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5473-747f-88f5-289114d37777",
        "storage_key": "property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5vy7FYvTIYRG8Gtzy1Pp6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_40eca6faa0f3d948e48d09cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "University of North Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1155 Union Cir, Denton, TX 76205, USA",
      "poi_short_description": "Expansive public research university founded in 1890 & known for its music school, among others.",
      "poi_long_description": "Expansive public research university founded in 1890 & known for its music school, among others.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-47f3-75d3-95b4-61e3e6ae9b2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-47f3-75d3-95b4-61e3e6ae9b2a",
        "storage_key": "property/5679206272860160/019f14fb-47f3-75d3-95b4-61e3e6ae9b2a.webp",
        "width": 1280,
        "height": 1002
      },
      "poi_business_url": "https://www.unt.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=846007427916065034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-texas",
      "poi_latitude": "33.2090389",
      "poi_longitude": "-97.153439",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 13 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 940-565-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyY815HPKTYYRCmlH-kWfvQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_6a0aa50219ae73d2d3c0b2aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Texas Woman's University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "304 Administration Dr, Denton, TX 76204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-344b-724e-90fb-952cbbb49a0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-344b-724e-90fb-952cbbb49a0f",
        "storage_key": "property/5679206272860160/019f14fb-344b-724e-90fb-952cbbb49a0f.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://twu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3936989001080651806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-womans-university",
      "poi_latitude": "33.2272211",
      "poi_longitude": "-97.127052",
      "poi_miles_from_property": "19.2 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 940-898-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a60a-7309-bce7-ce6e14637c3e",
        "storage_key": "property/5679206272860160/019d02f0-a60a-7309-bce7-ce6e14637c3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYTdn0oXKTYYRHkAILqP-ojY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_db49783dd7dedc33eb5c3826",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Denton County Public Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "190 N Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-3f9e-7579-bc2d-d1a06e01dda2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3f9e-7579-bc2d-d1a06e01dda2",
        "storage_key": "property/5679206272860160/019f14fb-3f9e-7579-bc2d-d1a06e01dda2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dentoncounty.gov/643/Public-Health",
      "poi_directions_map_url": "https://maps.google.com/?cid=2851363179355007494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denton-county-public-health",
      "poi_latitude": "33.0444958",
      "poi_longitude": "-97.0210956",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-434-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5473-747f-88f5-289114d37777",
        "storage_key": "property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9VCy-4tTIYRBmoVV7QTkic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_d885d7c7d65b0c94d08c18e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "Denton County Community Supervision and Corrections Department (Adult Probation)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 N Valley Pkwy #1064, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-43f0-7086-ac85-d20b334009a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-43f0-7086-ac85-d20b334009a7",
        "storage_key": "property/5679206272860160/019f14fb-43f0-7086-ac85-d20b334009a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dentoncounty.gov/626/Community-Supervision-Corrections-Depart",
      "poi_directions_map_url": "https://maps.google.com/?cid=3718408329966161732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denton-county-community-supervision-and-corrections-department-adult-probation",
      "poi_latitude": "33.046179",
      "poi_longitude": "-97.021584",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-434-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-5473-747f-88f5-289114d37777",
        "storage_key": "property/5679206272860160/019f14fb-5473-747f-88f5-289114d37777.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlUVmHO8tTIYRRI981axwmjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_4ab0595db8f7d750c8bb1d1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "poi_name": "The Vista Shopping Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2401 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14fa-d0c2-704f-a22d-63014c95af62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d0c2-704f-a22d-63014c95af62",
        "storage_key": "property/5679206272860160/019f14fa-d0c2-704f-a22d-63014c95af62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thevistacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8660594557472857579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vista-shopping-center",
      "poi_latitude": "33.0022926",
      "poi_longitude": "-96.9717506",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-315-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-a5db-774f-bcdb-dbb5339470f6",
        "storage_key": "property/5679206272860160/019d02f0-a5db-774f-bcdb-dbb5339470f6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ40kJKuQuTIYR693ZPd2cMHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    }
  ],
  "office_hours": [
    {
      "id": "custom_fea5396d-1bff-450b-ba0b-c806889d1758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bfe2a0e5-8eb0-4ec3-8bf4-c90d5dbdbe81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b754321c-ef42-421d-8b4b-ce01eb4e9e5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_783bd708-958a-4ab4-81ed-6514613fe3f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_ee3d9ea0-025d-4411-be75-78fc83dfb549",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_306f20cc-31b9-4f5b-8072-8b178e004b92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_0f5decbc-c007-41d7-b653-42bd87ce6460",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6371374d35622b0bd65bb6bf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "4",
      "name": "false",
      "text": "My husband and I are coming up on our 1 year lease renewal. The staff is what originally attracted me to the apartments. They were welcoming, they truly care, and all over they are willing to do whatever they can to help. \nCONS\nWhile the apartments are beautiful, when we moved in we were in love with it,but the more we looked the more there were flaws. The foundation moves constantly leaving us with cracks in the walls, doors not opening and shutting correctly, and therefore weather stripping is inconsistent.When they fixed the apartment before we moved in there were discolorations in the walls, trim damaged, laminate on the counters and floors peeling, and nails and screws in the carpet that were just left. All of our problems and concerns they have taken care of and made sure it was done quickly and correctly.\nThe area seems safe but within our last 6 months living there there has been 2 shootings and a murder, none of which were inside of the apartment complex, but were at the apartment complexes across the street which for us was worrisome and a huge factor into whether or not we were going to stay.\nPROS\nI cannot stress enough how amazing the apartment management is. They take their time to understand any situation and get to know you on a professional, yet personal level. They are very good about keeping everyone informed about what is going on in the community as well as with anything going on with the complex itself. The maintenance are all very sweet. They get things done correctly the first time and make sure to answer any questions as best as they can. The upkeep of the apartment grounds are consistent,well kept. There are tons of kids around the complex and it is a great place to have a family, yet I have never had problems with noise and I have 5 families around me all with multiple kids.\n\nNeedless to say, we have been pleased with them from the very start, and we will be staying here hopefully for a long time. We have amazing management, wonderful and quiet neighbors, and a beautiful and peaceful complex! I have and will continue to recommend my apartment complex.",
      "date": "false",
      "title": "AMAZING STAFF"
    },
    {
      "id": "ec_478b08f21b9a5967ca5b2c64",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "This is the first time I have ever lived alone in my life. I love my little apartment, the staff and the location. I would highly recommend this complex!",
      "date": "false",
      "title": "Love this place"
    },
    {
      "id": "ec_e94c36f6982db683c033483b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "I have been apartment hunting for some time now and I am so glad I came across this community! From the front office staff to maintenance, everyone has been so friendly and happy to help. Monica has made the process seamless for me. Definitely recommend. ",
      "date": "false",
      "title": "Hidden Gem"
    },
    {
      "id": "ec_d9eb15e462a421a3f6d2f413",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "Adorable floorplans with wonderful maintenance and front office staff!",
      "date": "false",
      "title": "Loved"
    },
    {
      "id": "ec_4facc2411baff53c6466718c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "Granite Countertops, stainless steel appliances and I love that the washers and dryers are included in the one-bedrooms. Maintenance is always fast and the office staff is always smiling. I’m happy to call this place home for a while. ",
      "date": "false",
      "title": "Love calling this place home! "
    },
    {
      "id": "ec_e8f137623233509cbb12c3a9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "Love the pool, dog park and that you get a free carport space! Thank you to everyone in the office for helping me with the moving process it was very smooth! ",
      "date": "false",
      "title": "Tucked away and I love it "
    },
    {
      "id": "ec_ab9468964c5ffb3a3df7a54a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "Excellent apartment complex, due to the excellence of the management team. ",
      "date": "false",
      "title": "Great place!"
    },
    {
      "id": "ec_d9d04cc98f73b38c12077837",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "The renovations look great and the area is super convenient. Would recommend!",
      "date": "false",
      "title": "Great Area and Prices"
    },
    {
      "id": "ec_c1eaa56e840658787f63740b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "With the new company that took over last year I’ve been very satisfied with the new maintenance quickly answering my service calls and the front office is always smiling. ",
      "date": "false",
      "title": "Happy to call The Aidan home"
    },
    {
      "id": "ec_77ff2f64967cba27d8ecde9c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "I have lived here for almost 2 years now and absolutely love the service I receive every time I walk in the door. I just love my home and all the upgrades, the view is so pretty at night and it’s always so peaceful. ",
      "date": "false",
      "title": "Can’t say enough about this place "
    },
    {
      "id": "ec_126a856fb877e02d2012f3b9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "rating": "5",
      "name": "false",
      "text": "I’ve had a very positive experience with The Aidan so far. The community is calm, quiet, and comfortable, and the entire leasing and move-in process went smoothly.\n\nA special thank you to Jonathan, who welcomed me from the beginning and personally took me on the community tour. Yecenia the Assistant Manager who was very accommodating and helped address my requests, and Diana\nwho was exceptionally kind, patient, attentive, and genuinely caring throughout the entire process.\n\nI also requested an assigned parking space, and the team arranged it for me upon moving in, which I truly appreciated.\n\nBased on my experience so far, I’m very happy with my decision to move to The Aidan and grateful for the excellent service provided by the team.",
      "date": "false",
      "title": "A Calm, Comfortable Community with an Outstanding Management Team"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_28d3220a893dff56219ede6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f14c3-803e-708b-af45-dfc5d86e50a8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-803e-708b-af45-dfc5d86e50a8",
        "storage_key": "property/5679206272860160/019f14c3-803e-708b-af45-dfc5d86e50a8.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Aidan Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/PjZFbdS7jko"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-ffa3-7732-b3d2-5c522bcafa17",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-aidan",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160"
    },
    {
      "lead_collector_id": "0198aa46-0005-7754-af06-637420d9f1d2",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-aidan",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160"
    },
    {
      "lead_collector_id": "0198aa46-0069-722e-ae30-0400e9c9a34f",
      "lead_source": "LANDING_PAGE",
      "name": "the-aidan",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "luxury-apartments-pool-lewisville-tx-935",
      "search_query": "luxury apartments with pool Lewisville TX",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Lewisville, TX",
      "h2_subtitle": "Discover luxury living at The Aidan with our stunning pool. Dive into relaxation and enjoy unparalleled amenities in Lewisville, TX.",
      "page_copy": "Welcome to The Aidan, where luxury apartments with a pool in Lewisville, TX redefine modern living. Nestled in the heart of Lewisville, our community offers sleek one, two, and three-bedroom floor plans equipped with top-tier amenities and stylish interiors. Step outside and enjoy our lavish resort-style pool, perfect for unwinding after a long day or weekend lounging.\n\nBeyond the pool, The Aidan boasts a fully-equipped fitness center and pet-friendly play areas. Our community's key fob entry ensures both convenience and security, while package services make receiving deliveries easy. Embrace the serene lifestyle you've been searching for. Schedule a tour at The Aidan today and experience the perfect blend of luxury and tranquility in Lewisville, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Lewisville, TX",
      "seo_description": "Experience The Aidan's luxury apartments with a pool in Lewisville, TX. Find your new home with resort-style amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-denton-county-611",
      "search_query": "pet friendly apartments with dog park in Denton County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet friendly apartments with a dog park in Denton County. The Aidan offers a perfect environment for both you and your furry friend.",
      "page_copy": "At The Aidan, we understand that pets are family, and that's why we offer pet friendly apartments with a dedicated dog park in Denton County. Located in the serene landscape of Lewisville/Flower Mound, our community is designed to cater to both you and your furry companions. Our spacious living options include one, two, and three-bedroom floor plans paired with modern amenities to ensure comfort and convenience.\n\nThe Aidan's dog park provides an ideal playground for your pets, giving them the freedom to run and play safely within the community. Additionally, enjoy our resort-style pool, a fully-equipped fitness center, and package services that cater to your busy lifestyle. Come and discover a welcoming, pet-centric home at The Aidan, where luxury meets pet-friendly living!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Park",
      "seo_description": "Find pet friendly apartments with a dog park in Denton County. The Aidan offers ideal living for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-lewisville-flower-mound-711",
      "search_query": "air conditioned apartments Lewisville Flower Mound",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Lewisville",
      "h2_subtitle": "Stay cool and comfortable in our air conditioned apartments in the Lewisville and Flower Mound area. Enjoy modern amenities at The Aidan.",
      "page_copy": "Experience ultimate comfort at The Aidan, where our air conditioned apartments in the Lewisville and Flower Mound area keep you cool year-round. With spacious one, two, and three-bedroom options, these modern residences are perfect for those seeking a balance between luxury and practicality. Our apartments not only feature efficient air conditioning systems but are also designed with stylish interiors and convenient amenities.\n\nLocated in a tranquil neighborhood, The Aidan offers resort-style facilities like a refreshing pool and a fully-equipped fitness center. Enjoy key fob entry for added security, and pet-friendly play areas for your furry companions. Whether you're enjoying the comfort inside or the vibrant community amenities, The Aidan is your perfect home in Lewisville/Flower Mound.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Lewisville",
      "seo_description": "Find comfortable air conditioned apartments in Lewisville and Flower Mound. Enjoy modern living at The Aidan with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-75067-715",
      "search_query": "apartments with dishwasher in 75067",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in 75067",
      "h2_subtitle": "Find convenient living with apartments featuring dishwashers in the 75067 area. Discover all that The Aidan offers!",
      "page_copy": "Discover the ease of modern living at The Aidan, where our apartments with dishwashers in the 75067 area come equipped with all the conveniences you desire. Our selection of one, two, and three-bedroom floor plans offers the perfect blend of style and efficiency. Say goodbye to handwashing dishes and hello to more free time, thanks to the thoughtfully designed kitchens featuring dishwashers.\n\nIn addition to this essential amenity, The Aidan provides a wealth of community features including a resort-style pool, fully-equipped fitness center, and pet-friendly play areas. With key fob entry, enjoy the peace of mind of secure living. Located in the charming Lewisville area, The Aidan is the ideal home base for convenience and luxury. Come visit us today and explore how our amenities make life easier!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in 75067",
      "seo_description": "Explore apartments with dishwashers in the 75067 area at The Aidan. Enjoy convenience and modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-lewisville-tx-507",
      "search_query": "in unit laundry apartments Lewisville TX",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in Lewisville",
      "h2_subtitle": "Enjoy the convenience of in unit laundry in our Lewisville, TX apartments. Discover modern living at The Aidan.",
      "page_copy": "At The Aidan, we elevate your living experience with in unit laundry apartments in Lewisville, TX. No need to worry about shared laundry spaces or having to leave home for this essential chore. Our one, two, and three-bedroom layouts feature convenient laundry facilities right inside your apartment, so you can enjoy more free time and less hassle.\n\nThe Aidan stands out with more than just in unit laundry. Our residents love the resort-style pool, modern fitness center, and secure key fob entry. Whether you're relaxing on your patio or taking your pet for a stroll in our play areas, our community offers a perfect blend of convenience and luxury. Make The Aidan your next home and experience carefree living in beautiful Lewisville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments in Lewisville",
      "seo_description": "Live in comfort with in unit laundry at The Aidan in Lewisville, TX. Enjoy luxurious amenities and convenient living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-lewisville-tx-925",
      "search_query": "one bedroom apartments lewisville tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Lewisville, TX",
      "h2_subtitle": "Discover stylish one bedroom apartments in Lewisville, TX at The Aidan. Enjoy modern amenities and luxury living.",
      "page_copy": "Discover the charm and convenience of our one bedroom apartments in Lewisville, TX at The Aidan. Designed with your lifestyle in mind, these apartments offer spacious layouts featuring modern kitchens equipped with microwaves and dishwashers. Embrace the clean, contemporary design that provides a comfortable and inviting space you’ll be proud to call home.\n\nThe Aidan isn’t just about great interiors—our community amenities like the resort-style pool and fitness center enhance your living experience. Whether you’re enjoying a peaceful moment on your private patio or partaking in our pet-friendly environment, there’s something for everyone. With key fob entry and package service, relish the ease and security of living at The Aidan, where luxury meets practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Lewisville, TX",
      "seo_description": "Find modern one bedroom apartments in Lewisville, TX at The Aidan. Enjoy top amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "two-bedroom-floor-plans-denton-county-919",
      "search_query": "two bedroom floor plans denton county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in Denton County",
      "h2_subtitle": "Explore our spacious two bedroom floor plans in Denton County at The Aidan. Enjoy luxury living in a prime location.",
      "page_copy": "Experience the perfect combination of style and comfort with our two bedroom floor plans in Denton County at The Aidan. Each apartment is designed to provide ample space and modern features, making it an ideal choice for small families or roommates. Our kitchens come equipped with all the essentials, including microwaves and dishwashers, providing a functional and stylish living environment.\n\nResidents of The Aidan enjoy a selection of amenities that extend beyond their front doors. From a refreshing resort-style pool to a comprehensive fitness center, our community is created with your lifestyle in mind. Located in serene Lewisville, The Aidan offers easy access to everyday conveniences and a tranquil setting. Schedule a tour today and see why our two bedroom layouts are the perfect fit for you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans in Denton County",
      "seo_description": "Discover spacious two bedroom floor plans in Denton County at The Aidan. Experience modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-flower-mound-162",
      "search_query": "three bedroom apartments near flower mound",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Flower Mound",
      "h2_subtitle": "Find expansive three bedroom apartments near Flower Mound at The Aidan. Experience luxury and convenience in Lewisville, TX.",
      "page_copy": "Discover the perfect family-friendly home with our three bedroom apartments near Flower Mound at The Aidan. Each apartment offers generous living spaces combined with modern design elements, making it suitable for families seeking both comfort and style. The open layouts feature gourmet kitchens with modern appliances, plenty of storage, and spacious bedrooms, ensuring that every family member has their own space.\n\nAt The Aidan, the amenities extend beyond luxurious interiors. Dive into our resort-style pool, stay fit in our state-of-the-art fitness center, or enjoy a leisurely day in the pet-friendly areas. Our Lewisville location, just a short drive from Flower Mound, combines the tranquility of suburbia with the convenience of urban access. Visit The Aidan today to explore luxury living and community in a prime Denton County location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Flower Mound",
      "seo_description": "Discover spacious three bedroom apartments near Flower Mound at The Aidan. Enjoy luxury amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "apartments-near-medical-city-lewisville-924",
      "search_query": "apartments near medical city lewisville",
      "category": "Hospital",
      "h1_title": "Apartments Near Medical City Lewisville",
      "h2_subtitle": "Find convenient apartments near Medical City Lewisville at The Aidan. Enjoy modern living close to key amenities.",
      "page_copy": "For those seeking convenience and style, discover the perfect living spaces at The Aidan, located near Medical City Lewisville. Our community offers a range of modern one, two, and three-bedroom apartments designed with functionality and elegance in mind. Enjoy high-quality amenities including a fully-equipped fitness center, resort-style pool, and cozy patios, providing everything you need right at your fingertips.\n\nLiving at The Aidan means having both comfort and accessibility. Situated in vibrant Lewisville, our location provides quick access to Medical City, making it ideal for healthcare professionals or those requiring frequent visits. With amenities like key fob entry and package service, experience the ease and peace of mind that comes with contemporary apartment living. Schedule a visit today and see why The Aidan is the ideal place to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Medical City Lewisville",
      "seo_description": "Find apartments near Medical City Lewisville at The Aidan. Enjoy modern amenities and close proximity to healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "rentals-close-to-texas-health-presbyterian-flower-mound-396",
      "search_query": "rentals close to texas health presbyterian hospital flower mound",
      "category": "Hospital",
      "h1_title": "Rentals Close to Texas Health Presbyterian",
      "h2_subtitle": "Discover quality rentals close to Texas Health Presbyterian Hospital Flower Mound. Enjoy the best of modern living at The Aidan.",
      "page_copy": "Located close to Texas Health Presbyterian Hospital Flower Mound, The Aidan offers the perfect rentals for those seeking convenience and tranquility. Our spacious one, two, and three-bedroom apartment homes are designed with modern amenities and stylish finishes, making them ideal for anyone looking to balance work with relaxation. Each unit includes a fully-fitted kitchen, comfortable living spaces, and a patio where you can unwind after a busy day.\n\nThe Aidan boasts exceptional community features such as a resort-style pool, fitness center, and pet-friendly areas. Living here provides easy access not only to healthcare facilities but also to everyday conveniences in the Lewisville/Flower Mound area. Residents of The Aidan enjoy both luxury and accessibility wrapped into one beautiful package. Visit us today to find out why our rentals are the best choice near Texas Health Presbyterian Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Texas Health Presbyterian",
      "seo_description": "Explore rentals close to Texas Health Presbyterian Hospital Flower Mound at The Aidan. Enjoy luxurious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "apartments-near-rockledge-park-lewisville-870",
      "search_query": "apartments near Rockledge Park Lewisville",
      "category": "Park",
      "h1_title": "Apartments Near Rockledge Park Lewisville",
      "h2_subtitle": "Explore modern living at The Aidan, with unrivaled access to the natural beauty of Rockledge Park, Lewisville. Discover your perfect home today!",
      "page_copy": "Nestled in the heart of Lewisville, The Aidan offers stunning apartments near Rockledge Park. These residences combine modern design with unparalleled access to one of the most beautiful natural reserves in the area. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, each equipped with top-tier amenities such as key fob entry and a fully-equipped kitchen.\n\nEnjoy a seamless blend of relaxation and adventure by living near Rockledge Park. Whether you're indulging in a serene walk or engaging in recreational activities at the park, The Aidan enhances your lifestyle with additional amenities including a resort-inspired pool and a fitness center. Experience the vibrant community and nature's bounty all in one location. Schedule a visit to The Aidan and immerse yourself in a lifestyle that's both luxurious and conveniently connected to nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rockledge Park Lewisville",
      "seo_description": "Discover The Aidan's apartments near Rockledge Park in Lewisville. Enjoy luxury living with natural beauty just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "lewisville-tx-apartments-near-oak-grove-park-176",
      "search_query": "Lewisville TX apartments near Oak Grove Park",
      "category": "Park",
      "h1_title": "Lewisville TX Apartments Near Oak Grove Park",
      "h2_subtitle": "Discover the ideal Lewisville TX apartments near Oak Grove Park at The Aidan. Enjoy both comfort and convenience in a stunning natural setting.",
      "page_copy": "The Aidan offers exquisite Lewisville TX apartments near Oak Grove Park, where residents can revel in both luxury and nature. Our thoughtfully crafted one, two, and three-bedroom apartments provide modern interiors that seamlessly integrate with the tranquil surroundings. Each home is equipped with must-have features like a microwave and a private patio, perfect for enjoying the serene environment.\n\nJust moments away from the picturesque Oak Grove Park, The Aidan ensures you’re never far from outdoor adventures and scenic views. The community is enriched with access to top-notch amenities including a sparkling pool and a well-equipped fitness center, providing a perfect complement to the natural beauty around you. Discover why The Aidan is the premier choice for those seeking a harmonious lifestyle close to Oak Grove Park, Lewisville TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville TX Apartments Near Oak Grove Park",
      "seo_description": "Find your home at The Aidan, offering Lewisville TX apartments near Oak Grove Park. Luxury meets nature with modern amenities and scenic beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "denton-county-apartments-by-andrew-brown-park-east-62",
      "search_query": "Denton County apartments by Andrew Brown Park East",
      "category": "Park",
      "h1_title": "Denton County Apartments by Andrew Brown Park",
      "h2_subtitle": "Explore premier Denton County apartments by Andrew Brown Park East at The Aidan. Experience serene living with top-tier amenities close by.",
      "page_copy": "Discover the perfect Denton County apartments by Andrew Brown Park East at The Aidan, where luxury living meets natural elegance. Our community offers a selection of one, two, and three-bedroom apartments, thoughtfully designed with modern amenities such as key fob entry and spacious interiors. Whether you're preparing meals in our fully equipped kitchens or relaxing on your private patio, The Aidan has it all.\n\nLocated just a short drive from Andrew Brown Park East, The Aidan ensures you're never far from beautiful green spaces and outdoor activities. Immerse yourself in the vibrant lifestyle with resort-style amenities like a refreshing pool and a state-of-the-art fitness center, complementing the natural beauty surrounding you. Choose The Aidan for a harmonious blend of comfort and convenience in the heart of Denton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Denton County Apartments by Andrew Brown Park",
      "seo_description": "Live at The Aidan, top Denton County apartments by Andrew Brown Park East. Enjoy luxury amenities amidst natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5679206272860160",
      "source": "custom",
      "page_item_url": "apartments-near-north-carrollton-frankford-station-42",
      "search_query": "apartments near north carrollton frankford station lewisville",
      "category": "Transit",
      "h1_title": "Apartments Near North Carrollton Frankford Station",
      "h2_subtitle": "Discover convenient living with apartments near North Carrollton Frankford Station at The Aidan. Enjoy seamless transit and luxury amenities.",
      "page_copy": "The Aidan offers exceptional apartments near North Carrollton Frankford Station in Lewisville, perfect for those seeking convenient transit options alongside luxurious living. Our selection of one, two, and three-bedroom apartments provide modern comfort with features like key fob entry and a private patio, making daily living both secure and enjoyable.\n\nEmbrace the ease of having quick access to North Carrollton Frankford Station, enhancing your commuting experience. The Aidan not only provides excellent accessibility but also offers a plethora of amenities such as a shimmering pool and a state-of-the-art fitness center. Whether you're commuting for work or leisure, The Aidan is your gateway to a vibrant lifestyle that combines convenience with sophisticated living. Schedule a tour today and elevate your living experience in Lewisville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a large stone fireplace.",
        "public_id": "019f6c11-010a-768d-8fa2-d6f31da82001",
        "storage_key": "property/5679206272860160/019f6c11-010a-768d-8fa2-d6f31da82001.webp",
        "width": 493,
        "height": 395
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near North Carrollton Frankford Station",
      "seo_description": "Find convenience and luxury at The Aidan, offering apartments near North Carrollton Frankford Station in Lewisville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2197"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470924"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4786611"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K3LXJF9"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://theaidan.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443907420"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywyj7qowq0"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/05aee5f5-6b82-4ab4-977d-ca10e3803372"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "469-369-0837"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjkrL1hJTWRZdUNvbkljTW8rT2hEWWc9PSIsInZhbHVlIjoiOW1aS1JqMUY4dS8wd2pTamZYY1o0QT09IiwibWFjIjoiOGM1ODUxN2M0MDUxMmUwOGM3ZDM1Y2ZhNWJmODBiYmRkNWZhNWUwOWZjY2EyY2Y1OTA3ZWNhOGE1M2E4YzVjMCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2197",
  "custom_repli_id": "2376470924",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4786611",
  "custom_google_gtm_id": "GTM-K3LXJF9",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://theaidan.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443907420",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywyj7qowq0",
  "custom_self_guided_tour_url": "https://selftournow.com/property/05aee5f5-6b82-4ab4-977d-ca10e3803372",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "469-369-0837",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjkrL1hJTWRZdUNvbkljTW8rT2hEWWc9PSIsInZhbHVlIjoiOW1aS1JqMUY4dS8wd2pTamZYY1o0QT09IiwibWFjIjoiOGM1ODUxN2M0MDUxMmUwOGM3ZDM1Y2ZhNWJmODBiYmRkNWZhNWUwOWZjY2EyY2Y1OTA3ZWNhOGE1M2E4YzVjMCJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "a42de977-945a-464b-955c-296b80a135b9",
  "custom_audioeye_site_hash": "ca11bcf23695a4e75df9a9e88722c9a9"
};

export const generatedAt = '2026-11-03T20:32:05.143Z';
